/// <reference path="../../../typings/browser.d.ts" />
/// <reference path="../../../customtypings/selectize/selectize.d.ts" />
/// <reference path="../../../customtypings/angular-google-maps/angular-google-maps.d.ts" />
/// <reference path="../../../customtypings/angular-wizard/angular-wizard.d.ts" />
/// <reference path="../../../customtypings/parsley/parsley.d.ts" />

namespace Application.Controllers {
    'use strict';

    import BlockConfig = Application.Models.BlockConfig;
    import BlockConfigTS = Models.BlockConfigTS;
    import IBlock = Application.Models.IBlock;
    import IBlockConfigTS = Application.Models.IBlockConfigTS;
    import IBlockConnections = Models.IBlockConnections;
    import BlockConnections = Models.BlockConnections;
    import IBlockName = Models.IBlockName;
    import ICloseParameters = ngModal.ICloseParameters;
    import IIfaceIp = Models.IIfaceIp;
    import ISONDNSEntry = Models.ISONDNSEntry;
    import ISONDnsMap = Models.ISONDnsMap;
    import INetworkInterface = Models.INetworkInterface;
    import INetworkNodeConfig = Models.INetworkNodeConfig;
    import INodeWizardResponse = Controllers.INodeWizardResponse;
    import ITSIpAndPort = Application.Models.ITSIpAndPort;
    import IUpdateBlockConnection = Models.IUpdateBlockConnection;
    import PresetPathsNode = Application.Models.PresetPathsNode;
    import WzStep = angular.AngularWizard.WzStep;
    import BlockTypeNaturalKey = Application.Models.BlockTypeNaturalKey;
    import IRedundancyGroup = Application.Models.IRedundancyGroup;
    import Block = Application.Models.Block;
    import NetworkNode = Application.Models.NetworkNode;
    import INetworkNode = Application.Models.INetworkNode;
    import IBlockNameParameters = Application.Models.IBlockNameParameters;
    import NetworkNodeType = Application.Models.NetworkNodeType;
    import ValidationUtils = Application.Common.ValidationUtils;

    export interface INetworkNodeModalScope extends ng.IScope {
        node: Models.INetworkNode;
        originalNode: Models.INetworkNode;
        nodeTypes: Models.NetworkNodeType[];
        nicTypes: Object[];
        typeOfEvent: Object[];
        gateways: Models.IGateway[];
        mags: Models.INetworkNode[];
        initialStep: number;
        internet?: Models.INetwork;
        deviceGuiUrl?: string;
        deviceGuiUrlNoProxy?: string;
        monitorRoleAvailable?: boolean;
        monitorRoleChecked?: boolean;
        blockLimit: number;

        changeWorkflowMode:(status: boolean) => void;
        init: () => void;
        selectedType: Models.NetworkNodeType;
        selectize: Selectize.IApi<string, Models.NetworkNodeType>;
        modalClose: () => void;
        modalSave: () => void;
        loadTypeSelectize: () => void;
        geocodingResolve: (address: string) => void;
        geolocationResponses: google.maps.custom.IAddress[];
        next: () => void;
        canExitDetailsStep: () => Promise<boolean>;
        canExitSpecificStep: () => Promise<boolean>;
        canExitNetworkStep: () => Promise<boolean>;
        saveCreate: () => void;
        back: () => void;
        saveNetworkNodeAndClose: () => void;
        initMap: () => void;
        openAdminSettings: () => void;
        openAdminSettingsNoProxy: () => void;
        window: google.maps.custom.IWindow;
        searchModel: google.maps.custom.ISearchModel;
        map: google.maps.custom.IMapObject;
        searchbox: google.maps.custom.ISearchBox;
        defaultBounds: google.maps.LatLngBounds;
        showPlaceDetails: (place: google.maps.custom.IAddress) => void;
        getIdFromHref: (href: string) => number;
        toggleDhcp: (nic: Models.INetworkInterface, index: number) => void;
        nodeGuiUrl: string;
        nodeGuiUrlNoProxy: string;
        addNetworkInterface: () => void;
        removeNetworkInterface: (index: number) => void;
        nodeDetailsChanged: () => void;
        forwardTsChanged: () => void;
        validateInterface: (nic: Models.INetworkInterface) => boolean;
        canBeMobile: () => boolean;
        checkBlocksInUse: () => boolean;
        isVirtualizable: () => boolean;
        deleteBlock: (block: IBlockName) => void;

        isDisabledMap: IDisabledMap;
        createMarker: (lat: number, lng: number) => void;
        blocks: IBlockName[];
        toDeleteBlocks: IBlockName[];
        editionMode: boolean;
        originalSerialNumber: string;

        networks: Models.INetwork[];
        isSrt: boolean;
        containsStartPort: boolean;
        isSrtCaller: boolean;
        showUseSon: boolean;
        isNumberOfBlocksEditable: boolean;
        isIntinor: boolean;
        hasInputTargetPort: (block: IBlock) => boolean;
        hasOutputTargetPort: (block: IBlock) => boolean;
        jsonConfigChanged: (block: IBlockName) => void;
        maxPortValue: number;
        addBlock: () => void;

        renameBlocks: () => void;
        blockRenamed: (block: IBlockName) => void;
        suffixChanged: (block: IBlockName) => void;
        showAddBlock: boolean;
        jsonValidate: (block: IBlockName) => void;
        validatedJson: boolean[];
        validatedTsbpdDelay: boolean[];

        loadMoreBlocks: () => void;

        vnos: Models.Vno[];
        forwardVtsds: Models.NetworkNode[];
        selectedVtsd: NetworkNode;
        numberOfBlocksVtsd: number;
        selectedVno: {
            vno: Models.IVno;
        };
        selectHostname: () => void;
        selectBlockHostname: (block: IBlockName) => void;

        srtVersions: string[];
        srtVersionSelected: string;
        srtVersionChanged: (newValue: string) => void;

        copyToClipBoard: (elementId: string) => void;
        steps: ISteps;
        cpusToUseText: string;
        vtsdForward: NetworkNode;
        vtsdForwardBlocks: IBlock[];
        connectionsPerCpu: number;
        connectionsPerCpuOptions: number[];
        mediakindStreamSelected: number;
        mediakindStreams: number[];
        mediakindPortSelected: number;
        mediakindPorts: number[];
        connectionsPerCpuChanged: (newValue: number) => void;
        mediakindStreamChanged: (newValue: number) => void;
        mediakindPortChanged: (newValue: number) => void;
        forwardVtsdChanged: (newValue: NetworkNode) => void;

        changeNumberOfBlocks: () => void;

        sonHostnameChanged: () => void;

        somePresetPath: boolean;
        presetBlockNames:  string[];
        resetBlockName: (block: IBlockName) => string;
        updateIpsAndPorts: () => void;

        canBeRedundant: boolean;
        canDisplayBlock: (block: IBlockName) => boolean;

        validateNumberOfBlocks: () => boolean;
    }

    export interface IDisabledMap {
        [key: string]: boolean;
    }

    export interface INodeModalParameters {
        node: Models.INetworkNode;
        nodeTypes: Models.NetworkNodeType[];
        gateways: Models.IGateway[];
        mags: Models.INetworkNode[];
        initialStep: number;
        internet: Models.INetwork;
        deviceGuiUrl: string;
        deviceGuiUrlNoProxy: string;
    }

    export interface ISteps {
        DETAILS_STEP: string;
        SPECIFICS_STEP?: string;
        LOCATION_STEP: string;
        NETWORK_STEP: string;
        BLOCKS_STEP: string;
    }

    /**
     * NetworkNodeWizardController class
     */
    export class NetworkNodeModalController {
        public static templateUrl: string = "decorators/modals/network-node-modal.html";
        public static ID: string = "#id-network-node-modal";
        public static $name: string = "networkNodeModalController";
        public static $inject: string[] = ['$scope',
            'close',
            'node',
            'nodeTypes',
            'gateways',
            'mags',
            'initialStep',
            'internet',
            'deviceGuiUrl',
            'deviceGuiUrlNoProxy',
            '$timeout',
            'geocodeService',
            'networkNodeService',
            'WizardHandler',
            '$templateCache',
            'uiGmapGoogleMapApi',
            '$rootScope',
            'deviceGuiService',
            '$sce',
            'blockService',
            'networkService',
            'messageTranslationsService',
            'aclService',
            'ModalService',
            'userService',
            'vnoService',
            'blockConnectionBlocksService',
            'presetPathService',
            'sonAdapterService',
            'tsProbeService',
            'ipService'
        ];
        private static PARSLEY_VALIDATE_IP: string = 'validateIpAddress';
        private static PARSLEY_VALIDATE_MULTICAST: string = 'validateMulticast';
        private readonly MULTICAST_MAX_IP: string = "239.255.255.255";

        private static STEPS: ISteps = {
                DETAILS_STEP: 'Details',
                SPECIFICS_STEP: 'Specifics',
                LOCATION_STEP: 'Location',
                NETWORK_STEP: 'Network',
                BLOCKS_STEP: 'Blocks',
        };

        private cpuOptionsRx = [1, 2, 4, 8, 16];
        private cpuOptions = [1, 2, 4, 6, 8, 10, 16];
        private connectionsPerCpuOptions = this.cpuOptions;
        private mediakindStreams: number[] = [1, 2];
        private mediakindPorts: number[] = [1, 2];
        private nodesWithoutInput: number[] = [8, 13, 18, 27]; //ATM_DEC, VTS, VTS_DEST and VIRT-SRT-TX-LSTN
        private nodesWithoutOutput: number[] = [13, 18, 20, 26]; //VTS and VTS_DEST

        private originalBlocks: IBlock[];
        private mapInitiated: boolean;

        private locationSelectize: Selectize.IApi<string, google.maps.custom.IAddress>;
        private formValidatorHelper: {
            lastKnownName: string;
            lastKnownAlias: string;
            lastCheckedSerial: string;
            lastCheckedSerialValid: boolean;
            lastCheckedName: string;
            lastCheckedNameValid: boolean;
            lastCheckedType: string;
        };

        private selectNodeType: Models.NetworkNodeType = {
            name: "Select type",
            numInterfaces: undefined,
            id: undefined,
            vendor: undefined,
            href: undefined,
            interfaceDefs: undefined,
            manifest: undefined,
            dnsModelName: "",
            isNumberOfBlocksEditable: () => false,
            isIntinor: () => false,
            canUseSon: () => false,
            isSrt: () => false,
            isSrtCaller: () => false,
            containsStartPort:() => false,
            needsMftSerial: () => false,
            getTextForSpecificsTab: () => '',
            hasSignalInterfaceDNS: () => false,
            canBeRedundant: () => false,
        };

        private rootScopeWatcher: Function = new Function();

        private autoGeneratedBlockNames: { [key: string]: IBlockName } = {};
        private sonDnsEntry: ISONDNSEntry;

        private defaultNumberOfBlocks: number = 20;

        /**
         * Constructor of the class.
         */
        constructor(private $scope: INetworkNodeModalScope,
                    private close: (parameters: ngModal.ICloseParameters) => void,
                    private node: Models.INetworkNode,
                    private nodeTypes: Models.NetworkNodeType[],
                    private gateways: Models.IGateway[],
                    private mags: Models.INetworkNode[],
                    private initialStep: number,
                    private internet: Models.INetwork,
                    private deviceGuiUrl: string,
                    private deviceGuiUrlNoProxy: string,
                    private $timeout: ng.ITimeoutService,
                    private geocodeService: Services.GeocodeService,
                    private networkNodeService: Application.Services.NetworkNodeService,
                    private wizardHandler: angular.AngularWizard.WizardHandler,
                    private $templateCache: ng.ITemplateCacheService,
                    private uiGmapGoogleMapApi: ng.IPromise<Object>,
                    private $rootScope: Services.IFlexSettings,
                    private deviceGuiService: Services.DeviceGuiService,
                    private $sce: ng.ISCEService,
                    private blockService: Services.BlockService,
                    private networkService: Services.NetworkService,
                    private messageTranslationsService: Services.MessageTranslationsService,
                    private aclService: Services.AclService,
                    private modalService: ngModal.IModalService,
                    private userService: Services.UserService,
                    private vnoService: Services.VnoService,
                    private blockConnectionBlockService: Services.BlockConnectionBlocksService,
                    private presetPathService: Services.PresetPathService,
                    private sonAdapterService: Services.SonAdapterService,
                    private tsprobeService: Services.TsProbeService,
                    private ipService: Services.IpService) {

            this.$scope.init = async () => {
                this.loadVnos();
                this.loadVtsds();
                $timeout(() => {
                    window.altair_admin_common_init();
                }, 500);
                this.nodeTypes = this.nodeTypes.sort((a1: Models.NetworkNodeType, a2: Models.NetworkNodeType) => {
                    return a1.name.localeCompare(a2.name);
                });

                const parameters: INodeModalParameters = {
                    node: this.node,
                    nodeTypes: this.nodeTypes,
                    gateways: this.gateways,
                    mags: this.mags,
                    initialStep: this.initialStep,
                    internet: this.internet,
                    deviceGuiUrl: this.deviceGuiUrl,
                    deviceGuiUrlNoProxy: this.deviceGuiUrlNoProxy,
                };
                await this.initVariables(parameters);
                this.disableNonInitialSteps();
                this.addStepListeners();
                this.goToInitialStep(parameters.initialStep);
            };

            this.$scope.canExitDetailsStep = async (): Promise<boolean> => {
                if (this.isCustomErrorDisplayed()) {
                    this.cleanSelectNodeType();
                }
                if (!this.$scope.node.type.id) {
                    return false;
                } else if ((this.nameUnchanged() || await this.isNameAvailable()) && await this.serialCheck()) {
                        return true;
                } else{
                    return false;
                }
            }

            this.$scope.canExitSpecificStep = async (): Promise<boolean> => {
                if (this.isEditionMode()) {
                    return true;
                } else if (this.$scope.node.type.isSrt()) {
                    // Needed only for SRT RX
                    const nodeConfig: INetworkNodeConfig = this.$scope.node.config;
                    const multicastIpAndPort: ITSIpAndPort = nodeConfig !== undefined ? nodeConfig.srtMulticastIpAndPort : undefined;
                    const multicastIp: string = multicastIpAndPort !== undefined ? multicastIpAndPort.ip : "";
                    const mustContainStartPort: boolean = this.$scope.node.type.containsStartPort() && ! this.$scope.node.type.isSrtCaller();
                    // Check srt config and the multicast ip pattern, in case SRT Dist existMulticastPatternError will be false
                    let srtCheck: boolean = !this.existMulticastPatternError(multicastIp) &&
                        nodeConfig !== undefined && (!mustContainStartPort || nodeConfig.portRangeStart !== undefined);
                    if(this.$scope.node.config.srtMulticastIterateIp) {
                        srtCheck = srtCheck && this.validateSrtRxMulticast(multicastIp);
                    }
                    return srtCheck;
                } else {
                    return true;
                }
            }

            this.$scope.canExitNetworkStep = async (): Promise<boolean> => {
                let allReqFieldsFilled: boolean =this.$scope.node.networkInterfaces && this.$scope.node.networkInterfaces.every((nic: Models.INetworkInterface) => {
                    return nic.name && nic.ipAddress && this.$scope.validateInterface(nic);
                });
                return allReqFieldsFilled;
            }

            this.$scope.init();

            this.$scope.searchModel = {
                searchTerm: '',
            };
            this.$scope.connectionsPerCpuOptions = this.connectionsPerCpuOptions;
            this.$scope.mediakindStreams = this.mediakindStreams;
            this.$scope.mediakindPorts = this.mediakindPorts;
            this.$scope.monitorRoleChecked = this.$scope.node.config.monitorMode;
            this.$scope.blockLimit = this.defaultNumberOfBlocks;

            this.$scope.addBlock = () => {
                // We don't need to change the config NumberOfBlocks as that is only for creation time to auto generate blocks
                const numberOfBlocks: number = this.$scope.blocks.length + 1;
                this.getDefaultBlocksNames(numberOfBlocks).then((result: IBlockName[]) => {
                    if (result && result.length > 0) {
                        const defaultBlocks: IBlockName[] = result.filter((block: IBlockName) => {
                            let blockType: Models.BlockTypeNaturalKey = block.naturalKey;
                            return blockType !== 'MVP_SERVER' && blockType !== 'MVP_SERVER_TS' && blockType !== 'MVP_EXPORT';
                        }).map((block: IBlockName, i: number) => {
                            const jsonConfig: string = block.configAsJsonString ? block.configAsJsonString : JSON.stringify(block.config);
                            const config: Models.IBlockConfig = jsonConfig ? JSON.parse(jsonConfig) : block.config;
                            config.index = numberOfBlocks;
                            return {
                                name: block.name,
                                blockTypeId: block.blockTypeId,
                                appIndex: block.appIndex,
                                blockIndex: i,
                                naturalKey: block.naturalKey,
                                href: block.href,
                                config: config,
                                configAsJsonString: jsonConfig,
                                lockedName: false,
                            };
                        });
                        const blockAdded: IBlockName = defaultBlocks[defaultBlocks.length - 1];
                        this.$scope.blocks.push(blockAdded);
                        this.$timeout(() => {
                            const list: HTMLElement = document.getElementById('block-list-container');
                            list.scrollTop = list.scrollHeight + 50;
                        });
                    }
                    this.setBlocksTypeToShow();
                });
            };

            this.$scope.deleteBlock = (block: IBlockName) => {
                this.deleteBlock(block);
            };

            this.$scope.hasInputTargetPort = (block: IBlock) => {
                return this.hasInputTargetPort(block);
            };

            this.$scope.hasOutputTargetPort = (block: IBlock) => {
                return this.hasOutputTargetPort(block);
            };

            this.$scope.jsonConfigChanged = (block: IBlockName) => {
                if (block.config && block.config.ts) {
                    if (block.config.ts.ip === "") {
                        block.config.ts.ip = "0.0.0.0";
                        block.config.ts.port = Models.DEFAULT_PORT;
                    }
                    if (!block.config.ts.port) {
                        block.config.ts.port = Models.DEFAULT_PORT;
                    }
                }

                block.configAsJsonString = this.addSRTParameters(JSON.stringify(block.config), JSON.parse(block.config.srtConfig));
            };

            this.$scope.jsonValidate = (block: IBlockName) => {
                if (this.$scope.validatedJson.length === 0) {
                    this.$scope.validatedJson = new Array<boolean>(this.$scope.blocks.length);
                }
                try {
                    JSON.parse(block.configAsJsonString);
                    this.$scope.validatedJson[block.blockIndex] = true;
                    this.tsbpddelayValidate(block);
                } catch (e) {
                    this.$scope.validatedJson[block.blockIndex] = false;
                }
            };


            this.$scope.modalClose = (): void => {
                this.close(undefined);
            };

            this.$scope.next = async (): Promise<void> => {
                await this.next();
            };

            this.$scope.saveCreate = async (): Promise<void> => {
                await this.saveCreate();
            };

            this.$scope.back = (): void => {
                this.wizardHandler.wizard().previous();
            };

            this.$scope.canBeMobile = (): boolean => {
                return this.$scope.node.type &&
                    Common.Utils.getMobileDevicesTypeNames().indexOf(this.$scope.node.type.name) > -1;
            };

            this.$scope.checkBlocksInUse = (): boolean => {
                let blocksInUse = true;
                if(this.$scope.blocks) {
                    blocksInUse = false;
                    this.$scope.blocks.forEach((block: IBlockName) => {
                        if (this.checkInUse(block)) {
                            blocksInUse =  true;
                        }
                    });
                }
                return blocksInUse;
            };


            /*
            * Only some devices should allow the option to be virtualized
            * */
            this.$scope.isVirtualizable = (): boolean => {
                return this.$scope.node.type &&
                    NetworkNodeType.getVirtualizableDevicesTypeNames().indexOf(this.$scope.node.type.name) > -1;
            };

            this.$scope.validateInterface = (nic: Models.INetworkInterface): boolean => {
                return nic.dhcp || Common.Utils.validateIPAddress(nic.ipAddress);
            };

            this.$scope.saveNetworkNodeAndClose = async (): Promise<void> => {
                if (await this.shouldSaveNode()) {
                    this.prepareToSave();
                    if (!this.isEditionMode()) {
                        this.createNodeAndClose();
                    } else {
                        let blocksBeforeUpdate: IBlock[] = this.$scope.node.blocks;
                        await this.editNodeAndClose();
                        let probedBlocks: Models.IAllProbedBlocks = await this.tsprobeService.getAllProbedBlocks();
                        if (this.$scope.node.type.id === 13) {
                            this.updateNetworkProbes(probedBlocks, blocksBeforeUpdate);
                        }
                    }
                }
            };

            this.$scope.createMarker = (lat: number, lng: number): void => {
                let newMarkers: google.maps.custom.IMarker[] = [];
                this.geocodeService
                    .address(lat, lng)
                    .then((response: google.maps.custom.IGeocodingResponse) => {
                        if (response.results.length > 0) {
                            let marker: google.maps.custom.IMarker = {
                                idKey: 0,
                                place_id: response.results[0].place_id,
                                name: '',
                                latitude: lat,
                                longitude: lng,
                                templateurl: 'window.tpl.html',
                                templateparameter: undefined,
                                events: {
                                    click: (): void => {
                                        this.geocodeService
                                            .address(marker.latitude, marker.longitude)
                                            .then((res: google.maps.custom.IGeocodingResponse) => {
                                                this.$scope.window.templateparameter = res.results[0];
                                                this.$scope.searchModel.searchTerm = res.results[0].formatted_address;
                                                this.$scope.window.show = true;
                                            });
                                        this.$scope.window.coords = {
                                            latitude: marker.latitude,
                                            longitude: marker.longitude,
                                        };
                                    },
                                    dragstart: (): void => {
                                        this.$scope.window.show = false;
                                        this.$scope.searchModel.searchTerm = '';
                                    },
                                    dragend: (mrkr: google.maps.custom.IMarker): void => {
                                        this.geocodeService
                                            .address(mrkr.latitude, marker.longitude)
                                            .then((res: google.maps.custom.IGeocodingResponse) => {
                                                this.$scope.window.templateparameter = res.results[0];
                                                this.$scope.searchModel.searchTerm = res.results[0].formatted_address;
                                                this.$scope.window.show = true;
                                            });
                                        this.$scope.window.coords = {
                                            latitude: marker.latitude,
                                            longitude: marker.longitude,
                                        };
                                    },
                                },
                            };
                            newMarkers.push(marker);
                            this.$scope.window.coords = {
                                latitude: lat,
                                longitude:  lng,
                            };
                            this.$scope.window.templateparameter = response.results[0];
                            this.$scope.window.show = true;
                            this.$scope.map.markers = newMarkers;
                        }
                    });
            };

            this.$scope.nodeDetailsChanged = async (): Promise<void> => {
                this.checkIfEmptySerial();
                this.checkIfEmptyName();

                this.checkIfUnchangedSerial();
                this.checkIfUnchangedName();

                if ((this.isEditionMode() || !this.nameOrAliasChanged) && ( this.serialUnchanged() && this.nameUnchanged()) ) {
                    this.setPristine();
                }

                if ((this.$scope.blocks && this.$scope.blocks.length > 0 && this.nameOrAliasChanged()) || this.isEditionMode()) {
                    await this.renameBlocks();
                } else {
                    await this.loadBlocks();
                }
            };

            this.$scope.forwardTsChanged = async (): Promise<void> => {
                if (this.$scope.node.config.numberOfBlocks !== this.$scope.selectedVtsd.config.numberOfBlocks) {
                    this.$scope.node.config.numberOfBlocks = Number(this.$scope.selectedVtsd.config.numberOfBlocks);
                    await this.loadNewBlocks();
                }
                let blocks: IBlock[] = await this.blockService.blocksInNode(Number(this.$scope.selectedVtsd.id));
                blocks.sort(function(a: IBlock, b: IBlock) {
                    return a.id - b.id;
                });
                for (let i: number = 0; i < blocks.length; i++) {
                    let config = JSON.parse(this.$scope.blocks[i].configAsJsonString);
                    config.forwardBlockId = blocks[i].id;
                    this.$scope.blocks[i].configAsJsonString = JSON.stringify(config);
                }
            };


            this.$scope.renameBlocks = async (): Promise<void> => {
                await this.renameBlocks();
            };

            this.$scope.blockRenamed = async (block: IBlockName): Promise<void> => {
               await this.blockRenamed(block);
            };

            this.$scope.suffixChanged = (block: IBlockName) => {
                this.suffixChanged(block);
            };

            this.$scope.loadMoreBlocks = () => {
                let blockNumber = this.$scope.blocks.length || this.$scope.node.config.numberOfBlocks;
                if (this.$scope.blockLimit < blockNumber) {
                    if (this.$scope.blockLimit + 5 > blockNumber) {
                        this.$scope.blockLimit = blockNumber;
                    } else {
                        this.$scope.blockLimit += 5;
                    }
                }
            };

            this.$scope.sonHostnameChanged = async (): Promise<void> => {
                if (!node.config.sonHostname) {
                    node.config.useSon = false;
                }
                const dnsEntry: ISONDNSEntry = await this.sonAdapterService
                    .searchSONDNSEntries(this.node.config.sonHostname)[0];
                if (dnsEntry) {
                    this.node.config.sonHostname = dnsEntry.hostname;
                    await this.updateBlocksDnsConfig(dnsEntry);
                }
            };

            this.$scope.openAdminSettings = (): void => {
                let deviceGui: Models.DeviceGui = new Models.DeviceGui();
                deviceGui.guiUrl = this.$scope.nodeGuiUrl.toString();
                deviceGui.proxyType = this.$rootScope.backendConfig.flexoProxyType;
                deviceGuiService.notifyAdminSettingsAttempt(Common.Utils.strIdFromHref(this.$scope.node.href), deviceGui);
                window.open(this.$scope.nodeGuiUrl.toString(), '_blank');
            };

            this.$scope.openAdminSettingsNoProxy = (): void => {
                let deviceGui: Models.DeviceGui = new Models.DeviceGui();
                deviceGui.proxyType = 'NONE';
                deviceGui.guiUrl = this.$scope.nodeGuiUrlNoProxy.toString();
                deviceGuiService.notifyAdminSettingsAttempt(Common.Utils.strIdFromHref(this.$scope.node.href), deviceGui);
                window.open(this.$scope.nodeGuiUrlNoProxy.toString(), '_blank');
            };

            this.$scope.addNetworkInterface = (): void => {
                this.$scope.node.networkInterfaces.push(Models.NetworkInterface.createDefault());
            };

            this.$scope.removeNetworkInterface = (index: number): void => {
                this.$scope.node.networkInterfaces.splice(index, 1);
            };

            this.$scope.toggleDhcp = (nic: Models.INetworkInterface, index: number): void => {
                if (nic.dhcp && !nic.ipAddress) {
                    $timeout(() => {
                        nic.ipAddress = '0.0.0.0';
                        $(`#nic-${index}-ipAddress`).val('0.0.0.0').parsley().validate();
                    });
                }
            };


            this.$scope.initMap = (): void => {
                if (this.mapInitiated)
                    return;
                this.mapInitiated = true;
                this.$templateCache.remove('searchbox.tpl.html');
                this.$templateCache.put('searchbox.tpl.html',
                    '<input id="pac-input" class="pac-controls" type="text" ng-model="ngModel" placeHolder="Search">');
                this.$templateCache.remove('window.tpl.html');
                this.$templateCache.put('window.tpl.html',
                    '<div ng-cloak style="z-index: 15000" ng-bind-html="parameter.formatted_address"></div>');

                this.$scope.window = {
                    show: false,
                    options: {
                        pixelOffset: {
                            width: 0,
                            height: -40,
                        },
                    },
                    templateurl: 'window.tpl.html',
                    templateparameter: {},
                    closeClick: (): void => {
                        this.$scope.window.show = false;
                    },
                    coords: {},
                };

                this.$scope.map = {
                    control: {},
                    center: {
                        latitude: 40.4902688,
                        longitude: -3.6932825,
                    },
                    zoom: 10,
                    dragging: true,
                    bounds: {},
                    markers: [],
                    idkey: 'place_id',
                    events: {
                        click: (map: google.maps.Map, event: string, attr: google.maps.MouseEvent): void => {
                            this.$scope.createMarker(attr[0].latLng.lat(), attr[0].latLng.lng());
                        },
                    },
                    options: {
                        streetViewControl: false,
                        mapTypeControl: false,
                        scaleControl: false,
                        rotateControl: false,
                        zoomControl: true,
                        maxZoom: 22,
                        minZoom: 3,
                    },
                    markerOptions: {
                        draggable: true,
                    },
                };

                this.$scope.searchbox = {
                    template: 'searchbox.tpl.html',
                    position: 'top-left',
                    options: {
                        bounds: {},
                    },
                    events: {
                        places_changed: (searchBox: google.maps.places.SearchBox): void => {
                            let places: google.maps.places.PlaceResult[] = searchBox.getPlaces();
                            if (places.length === 0)
                                return;
                            // for each place, get the icon, place name, and location.
                            let newMarkers: google.maps.custom.IMarker[] = [];
                            let bounds: google.maps.LatLngBounds = new google.maps.LatLngBounds();
                            for (let i: number = 0; i < places.length; i++) {
                                if (places[i] !== undefined) {
                                    // create a marker for each place.
                                    let marker: google.maps.custom.IMarker = {
                                        idKey: i,
                                        place_id: places[i].place_id,
                                        name: places[i].name,
                                        latitude: places[i].geometry.location.lat(),
                                        longitude: places[i].geometry.location.lng(),
                                        templateurl: 'window.tpl.html',
                                        templateparameter: places[i],
                                        events: {
                                            click: (map: google.maps.Map,
                                                    event: string,
                                                    clickedMarker: google.maps.custom.IMarker): void => {
                                                this.geocodeService
                                                    .address(clickedMarker.latitude, clickedMarker.longitude)
                                                    .then((res: google.maps.custom.IGeocodingResponse) => {
                                                        this.$scope.window.templateparameter = res.results[0];
                                                        this.$scope.searchModel.searchTerm = res.results[0].formatted_address;
                                                        this.$scope.window.show = true;
                                                    });
                                                this.$scope.window.coords = {
                                                    latitude: clickedMarker.latitude,
                                                    longitude: clickedMarker.longitude,
                                                };
                                            },
                                            dragstart: (): void => {
                                                this.$scope.window.show = false;
                                                this.$scope.searchModel.searchTerm = '';
                                            },
                                            dragend: (map: google.maps.Map,
                                                      event: string,
                                                      draggedMarker: google.maps.custom.IMarker): void => {
                                                this.geocodeService
                                                    .address(draggedMarker.latitude, draggedMarker.longitude)
                                                    .then((res: google.maps.custom.IGeocodingResponse) => {
                                                        this.$scope.window.templateparameter = res.results[0];
                                                        this.$scope.searchModel.searchTerm = res.results[0].formatted_address;
                                                        this.$scope.window.show = true;
                                                    });
                                                this.$scope.window.coords = {
                                                    latitude: draggedMarker.latitude,
                                                    longitude: draggedMarker.longitude,
                                                };
                                            },
                                        },
                                    };
                                    newMarkers.push(marker);
                                    bounds.extend(places[i].geometry.location);
                                    this.$scope.window.coords = {
                                        latitude: places[i].geometry.location.lat(),
                                        longitude:  places[i].geometry.location.lng(),
                                    };
                                    this.$scope.window.templateparameter = places[i];
                                    this.$scope.window.show = true;
                                }
                            }
                            this.$scope.map.bounds = {
                                northeast: {
                                    latitude: bounds.getNorthEast().lat(),
                                    longitude: bounds.getNorthEast().lng(),
                                },
                                southwest: {
                                    latitude: bounds.getSouthWest().lat(),
                                    longitude: bounds.getSouthWest().lng(),
                                },
                            };
                            this.$scope.map.markers = newMarkers;
                        },
                    },
                };

                this.$timeout(() => {
                    this.uiGmapGoogleMapApi.then((maps: google.maps.custom.IGMapApiPromiseObject) => {
                        let latLong: number[] = [];
                        latLong.push(this.$scope.node.geoElement.manualLat ? this.$scope.node.geoElement.manualLat : 40.4902688);
                        latLong.push(this.$scope.node.geoElement.manualLong ? this.$scope.node.geoElement.manualLong : -3.6932825);
                        this.$scope.map.center = { latitude: latLong[0], longitude: latLong[1] };
                        if (this.$scope.node.geoElement && !this.$scope.node.geoElement.auto &&
                            this.$scope.node.geoElement.manualLat && this.$scope.node.geoElement.manualLong) {
                            this.$scope.createMarker(latLong[0], latLong[1]);
                        }
                        maps.defaultBounds = true;
                        this.$scope.defaultBounds = new google.maps.LatLngBounds(
                            new google.maps.LatLng(latLong[0] - 0.5, latLong[1] - 0.5),
                            new google.maps.LatLng(latLong[0] + 0.5, latLong[1] + 0.5),
                        );
                        this.$scope.map.bounds = {
                            northeast: {
                                latitude: this.$scope.defaultBounds.getNorthEast().lat(),
                                longitude: this.$scope.defaultBounds.getNorthEast().lng(),
                            },
                            southwest: {
                                latitude: this.$scope.defaultBounds.getSouthWest().lat(),
                                longitude: this.$scope.defaultBounds.getSouthWest().lng(),
                            },
                        };
                        this.$scope.searchbox.options.bounds = new google.maps.LatLngBounds(
                            this.$scope.defaultBounds.getNorthEast(),
                            this.$scope.defaultBounds.getSouthWest(),
                        );
                    });
                });
            };


            this.$scope.resetBlockName = (block: IBlockName) => {
                let name: string = block.suffix && block.suffix.length > 0 ?
                    (node.alias ? node.alias + '_' + block.suffix : node.name + '_' + block.suffix)
                    : this.$scope.presetBlockNames[block.blockIndex];
                block.lockedName = false;
                return name;
            };

            this.$scope.srtVersionChanged = (newValue: string) => {
                this.$scope.srtVersionSelected = newValue;
                this.renameNetworkInterfaces();
            };

            this.$scope.$on('$destroy', () => {
                window.Parsley.removeValidator(NetworkNodeModalController.PARSLEY_VALIDATE_IP);
                window.Parsley.removeValidator(NetworkNodeModalController.PARSLEY_VALIDATE_MULTICAST);
                this.$templateCache.remove('searchbox.tpl.html');
                this.$templateCache.remove('window.tpl.html');
                this.rootScopeWatcher();

                if (this.$scope.selectize)
                    this.$scope.selectize.destroy();

                if (this.locationSelectize)
                    this.locationSelectize.destroy();
            });

            this.$scope.$watch('node.type', async (newType: Models.NetworkNodeType, oldType: Models.NetworkNodeType) => {
                if (newType) {
                    if ( newType !== oldType ) {
                        const key: string = 'isMobile';
                        this.$scope.node.config[key] = Common.Utils.getMobileDevicesTypeNames().indexOf(this.$scope.node.type.name) > -1;
                    }
                    this.$scope.isNumberOfBlocksEditable = this.node.type.isNumberOfBlocksEditable();
                    this.$scope.isIntinor = this.node.type.isIntinor();
                    this.$scope.node.config.numberOfBlocks = this.$scope.isNumberOfBlocksEditable && this.$scope.node.config.numberOfBlocks != undefined
                        ? Number(this.$scope.node.config.numberOfBlocks) : undefined;
                    if(this.$scope.node.config.forwardTS === undefined) {
                        this.$scope.node.config.forwardTS = $scope.node.type.name === "VIRTUAL-TS" ? false : undefined;
                    }
                    $scope.isSrt = this.$scope.node.type.isSrt();
                    $scope.containsStartPort = this.$scope.node.type.containsStartPort();
                    $scope.isSrtCaller = this.$scope.node.type.isSrtCaller();
                    if ($scope.node.type.name === "MEDIAKIND RX8200") {
                        $scope.mediakindStreamSelected = 1;
                        $scope.mediakindPortSelected = 1;
                    }
                    if ($scope.isSrt)
                        this.setSrtDefaults();

                    if (this.$scope.node.type !== undefined && this.$scope.node.href === '' && this.$scope.node.type.interfaceDefs) {
                        this.setInterfaces();
                    }

                    if (this.$scope.node.type !== undefined && this.formValidatorHelper.lastCheckedType !== this.$scope.node.type.href) {
                        this.validateType();
                        await this.loadBlocks();
                        this.formValidatorHelper.lastCheckedType = this.$scope.node.type.href;
                    }

                    if(this.$scope.node.type.id == 4 || this.$scope.node.type.id == 5 || this.$scope.node.type.id == 28){
                        this.$scope.monitorRoleAvailable = true;
                    }

                    this.$scope.monitorRoleAvailable = this.monitorRoleAvailable();

                    this.$scope.changeWorkflowMode= (status: boolean) => { this.changeWorkflowMode(status); }

                    this.$scope.showUseSon = this.showUseSon(this.$scope.node.type);
                    // If true  it will display a checkbox to select it or not.
                    this.$scope.canBeRedundant = this.canBeRedundant();
                    this.setSpecificsVisibility();
                    [this.getLocationStepTitle(), this.getNetworkStepTitle(), this.getBlocksStepTitle()]
                        .forEach((step: string) => {
                            this.disableStep(step);
                        });
                    if (!newType.needsMftSerial() && oldType.needsMftSerial()) {
                        this.node.mftSerialNumber = this.node.name;
                        this.formValidatorHelper.lastCheckedSerial = this.node.mftSerialNumber;
                    } else if (newType.needsMftSerial() && !oldType.needsMftSerial()) {
                        this.node.mftSerialNumber = '';
                    }
                    this.initSrt();
                }
            });

            this.$scope.$watch('node.geoElement.auto', (newAuto: boolean, oldAuto: boolean) => {
                if (newAuto === false && oldAuto) {
                    this.$scope.initMap();
                }
            });

            this.$scope.selectHostname = () => {
                this.openSONHostnameModal();
            };

            this.$scope.$watch('node.config.cpus', () => {
                this.$timeout(() => {
                    this.updateCpusToUse();
                    this.updateNumberOfBlocks();
                    this.updateIpsAndPorts();
                }, 250);
            });

            this.$scope.$watch('node.config.cpusOffset', () => {
                this.$timeout(() => {
                    this.updateCpusToUse();
                    this.loadBlocks();
                    }, 250);
            });

            this.$scope.$watch('node.config.processRtp2Udp', () => {
                this.$timeout(() => {
                    this.loadBlocks();
                }, 250);
            });

            /**
             * Method to watch if the isRedundant node parameter changes in order to update the block config
             */
            this.$scope.$watch('node.config.isRedundant', (newIsRedundant: boolean): void => {
                this.setRedundantBlockConfig(newIsRedundant);
            });

            this.$scope.updateIpsAndPorts = () => {
                this.updateIpsAndPorts();
            };

            // leave this to test blocks related issues
            // this.$scope.$watch('blocks', (newIsRedundant: boolean): void => {
            //    console.log("this.$scope.blocks: ", this.$scope.blocks);
            // });

            this.$scope.changeNumberOfBlocks = () => {
                this.validateForm();
                const numberOfBlocks: number = this.$scope.node.config.numberOfBlocks == null ? this.defaultNumberOfBlocks : this.$scope.node.config.numberOfBlocks;
                if (numberOfBlocks > 0) {
                    this.$timeout(async () => {
                        if (this.$scope.node.config.numberOfBlocks == null || numberOfBlocks === this.$scope.node.config.numberOfBlocks)
                            await this.loadBlocks();
                    }, 250);
                }
            };

            this.$scope.validateNumberOfBlocks = () => {
                return $scope.node.config.numberOfBlocks != null && ($scope.node.config.numberOfBlocks > Models.max_blocks || $scope.node.config.numberOfBlocks < Models.min_blocks);
            }

            this.$scope.selectBlockHostname = (block: IBlockName) => {
                this.openBlockSONHostnameModal(block);
            };

            this.$scope.copyToClipBoard = (elementId: string) => {
                const copyText: HTMLInputElement = document.getElementById(elementId) as HTMLInputElement;
                copyText.select();
                document.execCommand("copy");
            };

            this.$scope.connectionsPerCpuChanged = (newValue: number) => {
                this.$scope.connectionsPerCpu = newValue;
                this.updateNumberOfBlocks();
            };

            this.$scope.mediakindStreamChanged = (newValue: number) => {
                this.$scope.mediakindStreamSelected = newValue;
            };

            this.$scope.mediakindPortChanged = (newValue: number) => {
                this.$scope.mediakindPortSelected = newValue;
            };

            this.$scope.forwardVtsdChanged = async (newValue) => {
                if (this.$scope.node.config.numberOfBlocks !== newValue.config.numberOfBlocks) {
                    this.$scope.node.config.numberOfBlocks = Number(newValue.config.numberOfBlocks);
                    await this.loadNewBlocks();
                }
                let blocks: IBlock[] = await this.blockService.blocksInNode(Number(newValue.id));
                blocks.sort(function(a: IBlock, b: IBlock ) {
                    return a.id - b.id;
                });
                for (let i: number = 0; i < blocks.length; i++) {
                    let config = JSON.parse(this.$scope.blocks[i].configAsJsonString);
                    config.forwardBlockId = blocks[i].id;
                    this.$scope.blocks[i].configAsJsonString = JSON.stringify(config);
                }
            };

            /**
             * Method to check if a redundant block has to be displayed or not in the Blocks tab
             *
             * @param block information used to do the check
             * @return boolean true if can be displayed false otherwise
             */
            this.$scope.canDisplayBlock = (block: IBlockName): boolean => {
                // TODO: This method may be used in the future for different nodes, currently is only made for the ATEME-DR5000
                // TODO: that's why we use the block as parameter and we check the block.blockIndex === 0
                // TODO: ATEME-DR5000 only has one block and if it's redundant 2 but in the future it may change
                if (this.canBeRedundant() && this.node.config && !this.node.config.isRedundant) {
                    return block.blockIndex === 0;
                }
                return true;
            }
        }

        /**
         * This renames the network interfaces when SRT and version Alpha 13. For other versions the default names
         * will still the defined in the data base, defined in the changesets.
         */
        private renameNetworkInterfaces(): void {
            if (this.$scope.node.type.isSrt()
                && (this.$scope.srtVersionSelected === Models.ALPHA15)
                && this.$scope.node.networkInterfaces) {
                for (let i: number = 0; i < this.$scope.node.networkInterfaces.length; i++) {
                    if (this.$scope.node.type.interfaceDefs[i]) {
                        let networkInterface: INetworkInterface = this.$scope.node.networkInterfaces[i];

                        if (this.$scope.node.type.id === 16) { // Because SRT-GW-RX-LSTN has different names
                            if (networkInterface.name === "eth0")
                                networkInterface.name = "data2";
                            else if (networkInterface.name === "eth4")
                                networkInterface.name = "data1";
                            else if (networkInterface.name === "CONTROL")
                                networkInterface.name = "man";
                        }
                        else if (this.$scope.node.type.id === 24) {
                            if (networkInterface.name === "data0")
                                networkInterface.name = "data2";
                        }else {
                            if (networkInterface.name === "eth4")
                                networkInterface.name = "data1";
                            else if (networkInterface.name === "eth5")
                                networkInterface.name = "data2";
                            else if (networkInterface.name === "eth0")
                                networkInterface.name = "man";
                        }
                    }
                }
            }
        }

        /**
         * This set the multicast or srt interface for srt node.
         */
        private addMulticastOrSrtParam(): void {
            if (this.$scope.node.type.isSrt()) {
                if (this.$scope.node.networkInterfaces) {
                    this.$scope.node.networkInterfaces[1].multicastOrSrt = "Multicast";
                    this.$scope.node.networkInterfaces[2].multicastOrSrt = "SRT";
                    let key: string = 'multicastInterface';
                    this.$scope.node.config[key] = this.$scope.node.networkInterfaces[1].name;
                    key = 'srtInterface';
                    this.$scope.node.config[key] = this.$scope.node.networkInterfaces[2].name;
                }
            }
        }


        /**
         * This set the empty network interfaces for the network node.
         * These definitions are read from the database in the network_node_type table
         */
        private setInterfaces(): void {
            this.$scope.node.networkInterfaces = [];
            for (let i: number = 0; i < this.$scope.node.type.interfaceDefs.length; i++) {
                let interfaceDef: Models.NetworkInterfaceDef;
                if (this.$scope.node.type.interfaceDefs[i]) {
                    interfaceDef = this.$scope.node.type.interfaceDefs[i];
                }else {
                    interfaceDef = {'name': 'eth' + i, 'type': Models.NetworkInterfaceType.ANY};
                }
                this.$scope.node.networkInterfaces.push({
                    name: interfaceDef.name,
                    dhcp: true,
                    ipAddress: "0.0.0.0",
                    id: undefined,
                    connectionOptions: [
                        {
                            value: 'Not connected',
                            selected: true,
                        },
                        {
                            value: 'Internet',
                        },
                    ],
                    type: interfaceDef.type,
                });
            }
        }

        /**
         * This function populates the network interfaces of a given device if it is using SON and its nics can be
         * automatically linked
         * @param dnsMap
         */
        private updateNetworkInterfaceInfo(dnsMap: ISONDnsMap): void {
            if (dnsMap.entry && dnsMap.entry.model) {
                const mgmtIP: string = dnsMap.entry.ip.substring(0, dnsMap.entry.ip.indexOf("/"));
                let dataIps: IIfaceIp[] = dnsMap.findDataStreamIPs("if");
                let i: number = 0;
                this.$scope.node.networkInterfaces.forEach( (networkInterface: INetworkInterface) => {
                    if (networkInterface.type === Models.NetworkInterfaceType.CONTROL) {
                        networkInterface.ipAddress = mgmtIP;
                        networkInterface.dhcp = false;
                    } else {
                        if (dataIps[i] !== undefined && dataIps[i].ip !== undefined) {
                            networkInterface.ipAddress = dataIps[i].ip;
                            networkInterface.dhcp = false;
                        }
                        i++;
                    }
                });
            }
        }

        private setSrtDefaults(): void {
            if (!this.$scope.node.config.cpus) {
                this.$scope.node.config.cpus = 10;
            }
            if (this.node.type.name === NetworkNodeType.SRT_GW_TX_CALL) {
                if (!this.$scope.node.config.cpusOffset) {
                    this.$scope.node.config.cpusOffset = 2;
                }
            }
            else {
                if (!this.$scope.node.config.cpusOffset) {
                    this.$scope.node.config.cpusOffset = 5;
                }
            }

            if (!this.$scope.connectionsPerCpu) {
                this.$scope.connectionsPerCpu = 2;
            }
        }

        private nameOrAliasChanged(): boolean {
            const changed: boolean = this.formValidatorHelper.lastKnownName !== this.$scope.node.name ||
                this.formValidatorHelper.lastKnownAlias !== this.$scope.node.alias;
            this.formValidatorHelper.lastKnownName = this.$scope.node.name;
            this.formValidatorHelper.lastKnownAlias = this.$scope.node.alias;
            return changed;
        }

        private async enableAndGoToStep(stepTitle: string): Promise<void> {
            const stepNumber: number =  await this.enableAndGetStepNumber(stepTitle);
            this.goToStep(stepNumber);
        }

        private goToStep(stepNumber: number): void {
            this.wizardHandler.wizard().goTo(stepNumber - 1); // for some reason, index needed here
        }

        private async enableAndGetStepNumber(stepTitle: string): Promise<number> {
            if (stepTitle === this.getSpecificsStepTitle() ||
                stepTitle === this.getLocationStepTitle()) {
                this.setPristine();
            }
            this.enableStep(stepTitle);
            let stepNumber: number = this.getStepNumberByTitle(stepTitle);
            while (stepNumber < 1) {
                stepNumber = await this.getStepNumberByTitleTimeout(stepTitle);
            }
            return stepNumber;
        }

        private getStepNumberByTitleTimeout(stepTitle: string): ng.IPromise<number> {
            return this.$timeout(() => this.getStepNumberByTitle(stepTitle), 10);
        }

        private async next(): Promise<void> {
            const currentStep: number = this.wizardHandler.wizard().currentStepNumber(); // natural number, not array index
            const specificsOffset: number = this.shouldShowSpecifics() ? 1 : 0;
            switch (currentStep - specificsOffset) {
                case 0:
                    await this.continueToSpecificsStep();
                    break;
                case 1:
                    if (this.$scope.node) {
                        await this.continueToLocationStep();
                    }
                    break;
                case 2:
                    this.continueToNetworkStep();
                    break;
                case 3:
                    this.continueToBlocksStepOrFinish();
                    break;
                default:
                    break;
            }
        }

        private async saveCreate(): Promise<void> {
            const currentStep: WzStep = this.wizardHandler.wizard().currentStep();
            const shouldCheckSerial: boolean =
                (currentStep.title === this.getDetailsStepTitle() ||
                    currentStep.title === this.getSpecificsStepTitle()) &&
                this.$scope.originalSerialNumber !== this.$scope.node.mftSerialNumber;
            // check if the serial has changed and it is available and if the name has changed and it is available, then save the node
            const shouldSave: boolean = (!shouldCheckSerial || await this.isSerialNumberAvailable()) && (this.nameUnchanged() || await this.isNameAvailable());
            if (shouldSave) {
                this.saveCreateHelper();
            }
        }

        private saveCreateHelper(): void {
            if (this.isManualLocation()) {
                this.setManualLocation();
            }

            this.finish();
        }

        private isManualLocation(): boolean {
            return this.$scope.node.geoElement && !this.$scope.node.geoElement.auto &&
                this.$scope.window && this.$scope.window.coords as boolean;
        }

        private initSrt(srtVersion?: string, cpus?: number, numberOfBlocks?: number): void {
            this.$scope.srtVersions = [Models.ALPHA15, Models.ALPHA16, Models.ALPHA17];
            if (this.node.type.name === NetworkNodeType.SRT_GW_TX_LSTN || this.node.type.name === NetworkNodeType.SRT_GW_TX_CALL) {
                if (srtVersion === undefined ) {
                    srtVersion = Models.ALPHA15;
                }
            }
            if (this.node.type.name === NetworkNodeType.SRT_GW_RX_CALL) {
                this.$scope.srtVersions = [Models.ALPHA16, Models.ALPHA17];
                if (srtVersion === undefined ) {
                    srtVersion = Models.ALPHA16;
                }
            }

            this.setConnectionsPerCpu();
            this.$scope.srtVersionSelected = srtVersion
                ? srtVersion
                : Models.ALPHA15;
            this.$scope.connectionsPerCpu = numberOfBlocks && cpus
                ? numberOfBlocks / cpus
                : 2;
            this.renameNetworkInterfaces();
            this.addMulticastOrSrtParam();
        }

        private setConnectionsPerCpu() {
                if (this.node.type.name === NetworkNodeType.SRT_GW_TX_CALL ||
                    this.node.type.name === NetworkNodeType.SRT_GW_RX_CALL ||
                    this.node.type.name === NetworkNodeType.SRT_GW_TX_LSTN) {
                this.$scope.connectionsPerCpuOptions = this.cpuOptions;
            } else {
                this.$scope.connectionsPerCpuOptions = this.cpuOptionsRx;
            }
        }

        private prepareToSave(): void {
            if(this.$scope.isNumberOfBlocksEditable && this.$scope.node.type.id != 28) {
                this.$scope.node.config.numberOfBlocks = this.$scope.node.config.numberOfBlocks != undefined ? this.$scope.node.config.numberOfBlocks : this.defaultNumberOfBlocks;
            }
            this.$scope.node.organizationId = this.$scope.selectedVno.vno.id;
            this.$scope.node.organizationName = this.$scope.selectedVno.vno.name;

            this.$scope.node.physicalLocation =
                this.$scope.node.physicalLocation ? this.$scope.node.physicalLocation : '';

            if (this.$scope.node && this.$scope.node.type && this.$scope.node.type.isSrt() && this.$scope.node.config) {
                this.$scope.node.config.srtVersion = this.$scope.srtVersionSelected;
            }
            if (this.$scope.node && this.$scope.node.type && this.$scope.node.type.name === "MEDIAKIND RX8200" && this.$scope.node.config) {
                this.$scope.node.config.mediakindStream = this.$scope.mediakindStreamSelected;
                this.$scope.node.config.mediakindPort = this.$scope.mediakindPortSelected;
            }
        }

        /**
         * Adds the step change listeners
         */
        private addStepListeners() {
            this.rootScopeWatcher = this.$rootScope.$on("wizard:stepChanged", async (param1: Object, param2: { step: WzStep, index: number }) => {
                await this.checkPreviousSteps(param2.index);
                this.addMapLoaderListener(param2.index);
            });

            this.$rootScope.$on('wizard:stepChangeFailed', () => {
                this.validateForm();
            });
        }

        /**
         * Loads the map
         * @param stepIndex index of the step we are entering
         * @private
         */
        private addMapLoaderListener(stepIndex: number) {
            // google map load only can be done when the view/step is loaded
            if (stepIndex === 1 && !this.$scope.node.geoElement.auto) {
                this.$scope.initMap();
            }
        }

        /**
         * Validates the previous steps and if any validation is not ok goes back to that step
         * @param stepIndex index of the step we are entering
         * @private
         */
        private async checkPreviousSteps(stepIndex: number ) {
            let networkStepIndex: number = this.getStepIndexByTitle(this.$scope.steps.NETWORK_STEP);
            let specificStepIndex: number = this.getStepIndexByTitle(this.$scope.steps.SPECIFICS_STEP);

            if (specificStepIndex > 0 && stepIndex > specificStepIndex && !await this.$scope.canExitSpecificStep()) {
                this.goToStep(specificStepIndex +1);
                this.validateForm();
            } else if (networkStepIndex > 0 && stepIndex > networkStepIndex && !await this.$scope.canExitNetworkStep()) {
                this.goToStep(networkStepIndex + 1);
                this.validateForm();
            }
        }

        private goToInitialStep(initialStep: number): void {
            let isReady: boolean = false;

            this.$timeout(() => {
                if (!isReady) {
                    isReady = true;
                    if (initialStep) {
                        // TODO: improve this ugly hack
                        this.wizardHandler.wizard().goTo(this.shouldShowSpecifics() ? initialStep + 1 : initialStep);
                    }
                }
            }, 250);

        }

        private async initGui(deviceGuiUrl: string, deviceGuiUrlNoProxy: string): Promise<void> {
            let id: number = Common.Utils.idFromHref(this.$scope.node.href);
            if (!deviceGuiUrl || !deviceGuiUrlNoProxy ) {
                    if (await this.aclService.canAccessGui(id)) {
                        this.deviceGuiService.getDeviceGuiByIdPromise(id).then((deviceGui: Models.DeviceGui) => {
                            this.$scope.node.gui = deviceGui;
                            if (deviceGui.guiUrl && deviceGui.proxyType !== "HOST_DISABLED") {
                                this.$scope.nodeGuiUrl = this.$sce.trustAsResourceUrl(deviceGui.guiUrl);
                                this.$scope.nodeGuiUrlNoProxy = this.$sce.trustAsResourceUrl(deviceGui.guiUrlNoProxy);
                            }
                        });
                    }
            } else {
                this.$scope.nodeGuiUrl = deviceGuiUrl;
                this.$scope.nodeGuiUrlNoProxy = deviceGuiUrlNoProxy;
            }
        }

        private async initVariables(params: INodeModalParameters): Promise<void> {
            this.$scope.steps = NetworkNodeModalController.STEPS;
            const node: Models.INetworkNode = params.node;
            if (this.userService.getCurrentUser() !== undefined) {
                this.$scope.showAddBlock = this.userService.getCurrentUser().username === 'demiurgo';
            }
            this.$scope.validatedJson = [];
            this.$scope.validatedTsbpdDelay = [];
            this.$scope.toDeleteBlocks = [];
            this.$scope.maxPortValue = 50000;
            this.prepareMags(params.mags);
            this.addParsleyValidateIp();
            this.addParsleyValidateMulticast();
            node.preferredMag = node.preferredMag ? node.preferredMag : undefined;
            this.$scope.node = node;
            this.$scope.originalNode = Common.Utils.clone(node) as Models.INetworkNode;
            this.$scope.isDisabledMap = {};

            if (!this.$scope.node.type) {
                params.nodeTypes = [this.selectNodeType].concat(params.nodeTypes);
                this.$scope.node.type = params.nodeTypes[0];
            }
            this.$scope.editionMode = node.href && node.href !== '';
            this.$scope.isSrt = this.$scope.node.type.isSrt();
            this.$scope.containsStartPort = this.$scope.node.type.containsStartPort();
            this.$scope.isSrtCaller = this.$scope.node.type.isSrtCaller();
            this.$scope.showUseSon = this.showUseSon(this.$scope.node.type);
            this.$scope.isNumberOfBlocksEditable = this.isNumberOfBlocksEditable(this.$scope.node.type);
            this.$scope.isIntinor = this.isIntinor(this.$scope.node.type);
            this.setSpecificsVisibility();
            this.$scope.nodeTypes = params.nodeTypes;
            this.$scope.nicTypes = Models.NetworkInterfaceType.getValues();
            this.$scope.gateways = params.gateways;
            this.$scope.initialStep = params.initialStep;
            if (params.internet === undefined) {
                this.networkService.getNetworkById(1).then((data: Models.Network) => {
                    this.$scope.internet = data;
                });
            } else {
                this.$scope.internet = params.internet;
            }
            this.$scope.originalSerialNumber = this.isEditionMode() ? node.mftSerialNumber : undefined;
            this.locationSelectize = undefined;
            this.formValidatorHelper = {
                lastKnownName: undefined,
                lastKnownAlias: undefined,
                lastCheckedSerial: node.href ? node.mftSerialNumber : undefined,
                lastCheckedSerialValid: Boolean(node.href),
                lastCheckedNameValid: Boolean(node.href),
                lastCheckedName: node.href ? node.name : undefined,
                lastCheckedType: node.type.href,
            };
            this.mapInitiated = false;

            await this.loadBlocks();

            if (this.isEditionMode()) {
                await this.initGui(params.deviceGuiUrl, params.deviceGuiUrlNoProxy);

                this.$timeout(() => {
                    this.setPristine();
                    this.enableStep(this.getLocationStepTitle());
                    this.enableStep(this.getNetworkStepTitle());
                    if (this.$scope.blocks && this.$scope.blocks.length > 0)
                        this.enableStep(this.getBlocksStepTitle());
                });
            }
            if (params && params.node && params.node.type && params.node.type.isSrt && params.node.config) {
                this.initSrt(params.node.config.srtVersion, params.node.config.cpus,
                    this.$scope.blocks.length);
            }
            if (params && params.node && params.node.type && params.node.type.name === "MEDIAKIND RX8200" && params.node.config) {
                this.$scope.mediakindPortSelected = params.node.config.mediakindPort;
                this.$scope.mediakindStreamSelected = params.node.config.mediakindStream;
            }
        }

        private loadVnos(): void {
            this.vnoService.findAll().then((vnos: Models.Vno[]) => {
                this.$scope.vnos = vnos;
                if (vnos.length > 0) {
                    this.$scope.selectedVno = {vno: vnos[0]};
                }
            });
        }

        private loadVtsds(): void {
            this.networkNodeService
                .getAllByNetworkNodeTypeId(18)
                .then((networkNodes: NetworkNode[]) => {
                    this.$scope.forwardVtsds = networkNodes.sort((node1: NetworkNode, node2: NetworkNode) => node1.name.localeCompare(node2.name));
                    if (this.$scope.forwardVtsds.length > 0) {
                        this.$scope.selectedVtsd = this.$scope.forwardVtsds[0];
                    }
                });
        }

        private disableNonInitialSteps(): void {
            this.getNonInitialSteps().forEach((stepTitle: string) => this.disableStep(stepTitle));
        }

        private getNonInitialSteps(): string[] {
            return [this.getLocationStepTitle(),
                this.getNetworkStepTitle(),
                this.getBlocksStepTitle()];
        }

        /**
         * Returns the number of a step
         * @param title title of the step
         * @private
         */
        private getStepNumberByTitle(title: string): number {
            return this.getStepIndexByTitle(title) + 1; // natural number
        }

        /**
         * Returns the index of a step
         * @param title title of the step
         * @private
         */
        private getStepIndexByTitle(title: string): number {
            const foundStep: WzStep = this.wizardHandler.wizard().getEnabledSteps().filter((step: WzStep) =>
                step.title === title,
            )[0];
            return this.wizardHandler.wizard().getEnabledSteps().indexOf(foundStep);
        }

        private async continueToSpecificsStep(): Promise<void> {
            if (this.isCustomErrorDisplayed()) {
                this.cleanSelectNodeType();
            }

            if (await this.$scope.canExitDetailsStep()) {
                if (this.isEditionMode() && !this.$scope.isSrt) {
                    await this.continueToLocationStep();
                } else {
                    await this.enableAndGoToSpecifics();
                }
            } else {
                ValidationUtils.toggleParsleyWarningClasses('node-name', true, "Name");
                this.validateForm();
            }
        }

        /**
         * Check if all mandatory fields are filled and if the format is correct,
         * otherwise it will not continue to the next step
         */
        private async continueToLocationStep(): Promise<void> {
            if(await  this.$scope.canExitDetailsStep() && await this.$scope.canExitSpecificStep()) {
                await this.enableAndGoToLocation();
            } else {
                this.validateForm();
            }
        }

        /**
         * Method needed to check and refresh in the form that the multicast ip provided is valid
         * @param multicastIp the ip to be checked
         * @return true if there is a pattern error false otherwise
         */
        private existMulticastPatternError(multicastIp: string): boolean {
            const errorName: string = 'srtMulticastIpError';
            const multicastIpSelector: JQuery = $('[name="srtMulticastIp"]');
            // Remove the multicast ip pattern error in case it is displayed
            if (multicastIpSelector.length > 0) {
                multicastIpSelector.parsley().removeError(errorName, {updateClass: true});

                // Check srt config and the multicast ip pattern.
                if (multicastIp && multicastIp !== "" && !Common.IpUtils.ipIsMulticast(multicastIp)) {
                    // It will display an error if the multicast IP is invalid
                    multicastIpSelector.parsley().addError(errorName, {
                        message: 'Invalid Multicast IP',
                        updateClass: true,
                    });
                    return true;
                }
            }
            return false;
        }

        private async serialCheck(): Promise<boolean> {
            return !this.$scope.node.type.needsMftSerial() ||
                (this.formValidatorHelper.lastCheckedSerialValid && this.$scope.node.name && this.$scope.node.type.href && this.serialUnchanged()) ||
                (this.$scope.node.mftSerialNumber &&  await this.isSerialNumberAvailable());
        }

        /**
         * Method to check if the serial has changed
         * @return true if the serial didn't change
         */
        private serialUnchanged(): boolean {
            return this.formValidatorHelper.lastCheckedSerial === this.$scope.node.mftSerialNumber;
        }

        /**
         * Method to check if the name has changed
         * @return true if the name didn't change
         */
        private nameUnchanged(): boolean {
            return this.$scope.node.name &&
                (this.formValidatorHelper.lastCheckedName != undefined
                     && this.formValidatorHelper.lastCheckedName.toUpperCase() === this.$scope.node.name.toUpperCase());
        }

        private async continueToNetworkStep(): Promise<void> {
            if (this.isManualLocation()) {
                this.setManualLocation();
            } else {
                this.$scope.node.geoElement.auto = true;
            }
            await this.enableAndGoToNetwork();
        }

        private setManualLocation(): void {
            this.$scope.node.geoElement.manualLat = this.$scope.window.coords.latitude;
            this.$scope.node.geoElement.manualLong = this.$scope.window.coords.longitude;
            this.$scope.node.physicalLocation = this.$scope.window.templateparameter.formatted_address;
        }

        private async continueToBlocksStepOrFinish(): Promise<void> {
            let allReqFieldsFilled: boolean = await this.$scope.canExitNetworkStep();

            if (allReqFieldsFilled) {
                this.$scope.node.networkInterfaces.forEach((nic: Models.INetworkInterface) => {
                    if (nic.connectionOptions && nic.connectionOptions[1].selected) {
                        nic.networkConnectedTo = this.$scope.internet;
                        nic.connectedToInternet = true;
                        nic.connected = true;
                    }
                });

                if (this.$scope.blocks && this.$scope.blocks.length > 0) {
                    await this.enableAndGoToBlocks();
                } else {
                    this.finish();
                }
            } else {
                 this.validateForm();
            }
        }

        private finish(): void {
            this.validateForm();
            if (this.$scope.blocks && this.$scope.blocks.length > 0) {
                this.$scope.node.networkInterfaces.forEach((nic: Models.INetworkInterface) => {
                    if (nic.connectionOptions) {
                        if (nic.connectionOptions[1].selected === true) {
                            nic.networkConnectedTo = this.$scope.internet;
                            nic.connectedToInternet = true;
                            nic.connected = true;
                        }
                    }
                });
            }
            if (!this.$scope.blocks || this.$scope.blocks.every((block: IBlockName) => this.blockCheck(block))) {
                this.$scope.saveNetworkNodeAndClose();
            }
        }

        private blockCheck(block: IBlockName): boolean {
            const inputCheck: boolean = !this.hasInputTargetPort(block) ||
                Common.Utils.validatePortList(block.config.inputTargetPort);
            const outputCheck: boolean = !this.hasOutputTargetPort(block) ||
                Common.Utils.validatePortList(block.config.outputTargetPort);
            return block.name && inputCheck && outputCheck;
        }

        private async editNodeAndClose(): Promise<void> {

            const remainingBlocks: IBlockName[] = this.$scope.blocks
                .filter((block: IBlockName) => this.$scope.toDeleteBlocks
                    .filter((toDeleteBlock: IBlockName) => toDeleteBlock.name === block.name).length === 0);
            if (this.$scope.toDeleteBlocks.length !== 0 && remainingBlocks.length === 0) {
                // Network node with all blocks deleted, we delete the whole network node
                this.networkNodeService.deleteNetworkNode(this.$scope.node)
                    .then(() => {
                        this.blockService.deleteRedundantGroups(this.$scope.node);
                        this.close(undefined);
                    });
            } else {
                this.addMulticastOrSrtParam();
                const response: Models.NetworkNode = await this.networkNodeService.saveNetworkNode(this.$scope.node);
                this.$scope.toDeleteBlocks.forEach((block: IBlockName) => {
                    if (block.href) {
                        this.blockService.deleteRedundantGroup(block);
                        this.blockService.deleteBlock(Common.Utils.idFromHref(block.href));
                    }
                });

                for (const block of this.$scope.blocks) {
                    let originalBlock: IBlock;
                    [originalBlock] = this.originalBlocks.filter((b: IBlock) => b.href === block.href);

                    if (!originalBlock) {
                        // This is a new block added
                        const nodeId: number = parseInt(this.$scope.node.id, 10);
                        const blockName: string = block.name;
                        const blockTypeId: number = block.blockTypeId;
                        const blockConfig: string = block.configAsJsonString;
                        await this.blockService.generateAppAndBlock(nodeId, blockName, blockTypeId, blockConfig);
                    } else {
                        if (originalBlock.config.serial !== this.$scope.node.mftSerialNumber) {
                            originalBlock.config.serial = this.$scope.node.mftSerialNumber;
                        }
                        this.saveBlock(block, originalBlock);
                    }
                }
                let extendedResponse: INodeWizardResponse = {
                    networkNode: response,
                    new: false,
                };
                this.close(extendedResponse as ICloseParameters);
            }
        }

        private saveBlock(block: IBlockName, originalBlock: IBlock): void {
            let oldSerial = block.config.serial;
            try {
                block.config = Models.BlockConfig.Copy(JSON.parse(block.configAsJsonString));
                const index: number = originalBlock.config.index;
                const serial: string = originalBlock.config.serial;
                // Fixed When editing a vts block with redundancy, the redundancy info must be saved
                if (originalBlock.config.redundancyGroup) {
                    const redundancyGroup: IRedundancyGroup = originalBlock.config.redundancyGroup;
                    block.config.redundancyGroup = redundancyGroup;
                }
                block.config.index = index;
                block.config.serial = serial;
            } catch (e) {
                this.messageTranslationsService.alertOnError("Configuration format error");
                throw e;
            }

            const shouldSaveName: boolean = this.changeName(originalBlock, block);
            const shouldSaveConfig: boolean = this.changeBlockConfig(originalBlock, block) || oldSerial !== block.config.serial;

            if (shouldSaveName || shouldSaveConfig) {
                this.blockService.saveBlock(originalBlock);
            }
        }

        private changeName(originalBlock: IBlock, block: IBlockName): boolean {
            const saveBlockName: boolean = originalBlock.name !== block.name;
            if (saveBlockName) {
                originalBlock.name = block.name;
                originalBlock.lockedName = block.lockedName;
                originalBlock.suffix = block.suffix;
            }
            return saveBlockName;
        }

        private changeBlockConfig(originalBlock: IBlock, block: IBlockName): boolean {
            const saveBlockConfig: boolean = !block.config.equals(originalBlock.config);
            if (saveBlockConfig) {
                this.changeBlockConnection(originalBlock, block);
                originalBlock.config = block.config;
            }
            return saveBlockConfig;
        }

        private changeBlockConnection(originalBlock: IBlock, block: IBlockName): void {
            const blockConnectionChanged: boolean = block.config.inputTargetPort !== originalBlock.config.inputTargetPort ||
                block.config.outputTargetPort !== originalBlock.config.outputTargetPort || block.config.srtConfig !== originalBlock.config.srtConfig;
            if (blockConnectionChanged)
                this.saveBlockConnection(originalBlock, block);
        }

        private saveBlockConnection(originalBlock: IBlock, block: IBlockName): void {
            originalBlock.blockConnections.filter((blockConnection: IBlockConnections) => {
                if (blockConnection.direction === BlockConnections.DIRECTION_INPUT && blockConnection.push && blockConnection.connectionTypeName === 'SRT') {
                    return (blockConnection.targetPorts !== block.config.inputTargetPort);
                } else if (blockConnection.direction === BlockConnections.DIRECTION_OUTPUT && !blockConnection.push) {
                    return (blockConnection.targetPorts !== block.config.outputTargetPort);
                }
            }).forEach((blockConnection: IBlockConnections) => {
                blockConnection.targetPorts = blockConnection.push ? block.config.inputTargetPort : block.config.outputTargetPort;
                const updatedBlockConnection: IUpdateBlockConnection = {
                    id: blockConnection.id,
                    targetPorts: blockConnection.targetPorts,
                    parameters: blockConnection.parameters,
                };
                this.blockConnectionBlockService.updateBlockConnection(updatedBlockConnection);
            });
        }

        private createNodeAndClose(): void {
            this.$scope.node.config.blockNames = {
                generatedBlockNames: [],
                dirty: true,
            };
            this.removeRedundantBlocksIfNeeded();
            this.$scope.blocks.forEach((block: IBlockName) => {
                (this.$scope.node.config as any).blockNames.generatedBlockNames.push({ // tslint:disable-line
                    blockTypeId: block.blockTypeId,
                    name: block.name,
                    appIndex: block.appIndex,
                    blockIndex: block.blockIndex,
                    naturalKey: block.naturalKey,
                    configAsJsonString: block.configAsJsonString,
                    lockedName: block.lockedName,
                    suffix: block.suffix,
                });
            });
            this.addMulticastOrSrtParam();
            this.networkNodeService
                .saveNetworkNode(this.$scope.node)
                .then( async (response: Models.NetworkNode): Promise<any>  => {
                    let extendedResponse: INodeWizardResponse = {
                        networkNode: response,
                        new: true,
                    };

                    this.close(extendedResponse as ICloseParameters);

                    // delay to wait for node to be saved before update the block
                    await Common.Utils.delay(2000);

                    // if saved node is DR5000
                    if(response.type.id === 8){

                        // we need to relate primary and secondary block of redundancy (decoder)
                        // add to primary redundant block, the id of the secundary redundant block

                        const networkNodeId = response.id;
                        let blocks: IBlock[] = await this.blockService.blocksInNode(Number(networkNodeId));
                        if (blocks.length === 0) {
                            await new Promise(resolve => setTimeout(resolve, 1500));
                            blocks = await this.blockService.blocksInNode(Number(networkNodeId));
                        }
                        const createdRedundantBlock = blocks.filter((block: IBlock)=> {
                            return block.config.isRedundant === true;
                        });
                        const createdPrimaryBlock = blocks.filter((block: IBlock)=> {
                            return block.config.isRedundant != true;
                        });
                        createdPrimaryBlock[0].config.redundantBlockId = createdRedundantBlock[0].id;
                        this.blockService.updateBlock(createdPrimaryBlock[0]);
                  }
                }).catch(reason => {
                    console.log(reason);
                });
        }

        /**
         * Method needed to avoid the creation of the redundant blocks when not needed
         * The expected behaviour is to remove the redundant block if the node is not set as redundant:
         *  1. The node can be redundant?
         *  2. If yes, has the node been configured as redundant?
         *
         *  TODO: Make this method generic. Currently gets the first element and set the numberOfBlocks to 1 as we only support ATMETE DR-5000 redundancy
         */
        private removeRedundantBlocksIfNeeded(): void {
            if (this.canBeRedundant() && this.node.config && !this.node.config.isRedundant) {
                this.$scope.blocks = this.$scope.blocks.splice(0, 1);
                this.node.config.numberOfBlocks = 1;
                this.$scope.blocks[0].configAsJsonString = "{}";
            }
        }

        private async shouldSaveNode(): Promise<boolean> {
            return this.$scope.node.name &&
                this.$scope.node.mftSerialNumber &&
                this.$scope.node.type &&
                this.$scope.node.geoElement &&
                await this.$scope.canExitNetworkStep();
        }

        private isSerialNumberAvailable(): ng.IPromise<boolean> {
            return this.networkNodeService.checkUsedMftSerialNumberPromise(this.$scope.node.mftSerialNumber)
                .then((usedSerial) => {
                    if (usedSerial) {
                        this.formValidatorHelper.lastCheckedSerial = this.$scope.node.mftSerialNumber;
                        this.formValidatorHelper.lastCheckedSerialValid = false;
                        ValidationUtils.toggleParsleyWarningClasses('node-serial-number', true, "Serial");
                        return false;
                    } else {
                        ValidationUtils.toggleParsleyWarningClasses('node-serial-number', false, "Serial");
                        this.formValidatorHelper.lastCheckedSerial = this.$scope.node.mftSerialNumber;
                        this.formValidatorHelper.lastCheckedSerialValid = true;
                        if (this.$scope.node.type && this.$scope.node.type.interfaceDefs.length > 0 && this.$scope.node.name) {
                            return true;
                        }
                    }
                }).catch((reason: ngCustom.IReason) => {
                    this.messageTranslationsService.alertOnError("Something was wrong");
                    ValidationUtils.toggleParsleyWarningClasses('node-serial-number', false, "Serial");
                    this.formValidatorHelper.lastCheckedSerial = undefined;
                    this.formValidatorHelper.lastCheckedSerialValid = false;
                    return false;
                });
        }

        /**
         * Method to check if the name of the node is available
         *
         * @return boolean true if the name is available
         */
        private isNameAvailable(): ng.IPromise<boolean> {
            return this.networkNodeService.existsNodeName(this.$scope.node.name)
                .then((result: boolean) => {
                    if(result) {
                        this.formValidatorHelper.lastCheckedNameValid = false;
                        ValidationUtils.toggleParsleyWarningClasses('node-name', true, "Name");
                        return false;
                    }
                    else {
                        ValidationUtils.toggleParsleyWarningClasses('node-name', false, "Name");
                        this.formValidatorHelper.lastCheckedName = this.$scope.node.name;
                        this.formValidatorHelper.lastCheckedNameValid = true;
                        if (this.$scope.node.type && this.$scope.node.type.interfaceDefs && this.$scope.node.type.interfaceDefs.length > 0 &&
                            this.$scope.node.name) {
                            return true;
                        }
                        return false;
                    }
                }).catch((reason: ngCustom.IReason) => {
                    if (reason.status === Common.NOT_FOUND) {
                        ValidationUtils.toggleParsleyWarningClasses('node-name', false, "Name");
                        this.formValidatorHelper.lastCheckedName = this.$scope.node.name;
                        this.formValidatorHelper.lastCheckedNameValid = true;
                        if (this.$scope.node.type && this.$scope.node.type.interfaceDefs && this.$scope.node.type.interfaceDefs.length > 0 &&
                            this.$scope.node.name) {
                            return true;
                        }
                    } else {
                        this.messageTranslationsService.alertOnError("Something was wrong");
                        ValidationUtils.toggleParsleyWarningClasses('node-name', false, "Name");
                        this.formValidatorHelper.lastCheckedName = undefined;
                        this.formValidatorHelper.lastCheckedNameValid = false;
                        return false;
                    }
                });
        }

        private showUseSon(type: Models.INetworkNodeType): boolean {
            return type.canUseSon();
        }

        private monitorRoleAvailable(){
            if(this.$scope.node.type.id == 4 || this.$scope.node.type.id == 5|| this.$scope.node.type.id == 28){
                if (this.$scope.node.type.id == 28){
                    this.$scope.monitorRoleChecked = true;
                } else {
                    this.$scope.monitorRoleChecked = false;
                }
                return true;
            }
            return false;
        }

        private changeWorkflowMode(status: boolean){
            if(status == true){
                this.$scope.node.config.monitorMode = true;
            }else{
                this.$scope.node.config.monitorMode = false;
            }
        }

        /**
         * Method to check if a device allows redundancy
         *
         * @return boolean true if allows redundancy false otherwise
         */
        private canBeRedundant(): boolean {
            if (this.$scope.node && this.$scope.node.type && this.$scope.node.type.name && this.$scope.node.type.name.length > 0) {
                return this.$scope.node.type.canBeRedundant();
            }
            return false;
        }

        public isIntinor(type: Models.INetworkNodeType): boolean{
                return type.isIntinor();
        }

        private isNumberOfBlocksEditable(type: Models.INetworkNodeType): boolean {
            return type.isNumberOfBlocksEditable() && this.isEditionMode();
        }

        private tsbpddelayValidate(block: IBlockName): void {
            if (this.$scope.validatedTsbpdDelay.length === 0) {
                this.$scope.validatedTsbpdDelay = new Array<boolean>(this.$scope.blocks.length);
            }
            if (block.isConnected) {
                try {
                    const jsonConfig: Models.IBlockConfig = JSON.parse(block.configAsJsonString);
                    this.$scope.validatedTsbpdDelay[block.blockIndex] = jsonConfig.tsbpddelay === block.config.tsbpddelay;
                } catch (e) {
                    // do something?
                }
            }
            else {
                this.$scope.validatedTsbpdDelay[block.blockIndex] = true;
            }
        }

        private prepareMags(mags: Models.INetworkNode[]): void {
            this.$scope.mags = [];

            for (let mag of mags) {
                let newMag: Models.NetworkNode = Models.NetworkNode.Copy(mag);
                let networkName: string = '';

                // First network (not Internet) is used to display with the MAG name
                for (let nic of newMag.networkInterfaces) {
                    if (nic.connected && !nic.connectedToInternet) {
                        networkName = ' (' + nic.networkConnectedTo.name + ')';
                        break;
                    }
                }

                newMag.name += networkName;
                this.$scope.mags.push(newMag);
            }

            let empty: Models.NetworkNode = Models.NetworkNode.Empty();
            empty.name = "No preferred MAG";
            empty.href = undefined;
            this.$scope.mags.unshift(empty);

        }

        private async loadBlocks(): Promise<void> {
            this.$scope.blocks = this.$scope.blocks ? this.$scope.blocks : [];
            this.formValidatorHelper.lastKnownName = this.$scope.node.name;
            this.formValidatorHelper.lastKnownAlias = this.$scope.node.alias;
            if (this.isEditionMode()) {
                return await this.loadExistingBlocks();
            } else if (Common.Utils.exists(this.$scope.node.name) && this.$scope.node.name !== '' &&
                       Common.Utils.exists(this.$scope.node.type) && Common.Utils.exists(this.$scope.node.type.id)) {
                return await this.loadNewBlocks();
            } else {
                return Promise.resolve();
            }
        }

        private loadNewBlocks(): ng.IPromise<void> {
            return this.getDefaultBlocksNames(this.$scope.node.config.numberOfBlocks).then((result: IBlockName[]) => {
                if (result) {
                    if (result.length > 0) {
                        this.processNewBlocks(result).then( () => {
                            this.updateIpsAndPorts();
                        }
                        );
                    } else {
                        this.$scope.blocks = [];
                    }
                }
                this.setBlocksTypeToShow();
            });
        }

        /**
         * This method is in charge of the initial creation of the blocks
         *
         * @param blocks array with the information to be processed
         * @return Promise<void>
         */
        private async processNewBlocks(blocks: IBlockName[]): Promise<void> {
            this.$scope.blocks = blocks
                .map((block: IBlockName, i: number) => {
                    block.config = block.config ? block.config : new BlockConfig();

                    let jsonConfig: string = block.configAsJsonString ?
                        block.configAsJsonString : JSON.stringify(block.config);

                    if (this.$scope.isSrt) {
                        let params: {} = this.createSrtParamsConfig();
                        block.config.srtConfig = JSON.stringify(params);
                        jsonConfig = this.addSRTParameters(jsonConfig, params);
                    }

                    return {
                        id: block.id,
                        name: block.name,
                        blockTypeId: block.blockTypeId,
                        appIndex: block.appIndex,
                        blockIndex: i,
                        naturalKey: block.naturalKey,
                        href: block.href,
                        config: block.config,
                        configAsJsonString: jsonConfig,
                        lockedName: block.lockedName,
                        suffix: block.suffix,
                    };
                });
            this.autoGeneratedBlockNames = {};
            this.$scope.presetBlockNames = [];
            this.$scope.blocks.forEach((block: IBlockName, i: number) => {
                this.autoGeneratedBlockNames[block.name] = block;
                this.$scope.presetBlockNames[i] = block.name;
            });
            this.updateBlockLimit();
            if (this.sonDnsEntry) {
                await this.updateBlocksDnsConfig(this.sonDnsEntry);
            }
            // Set the redundancy, if possible
            if (this.canBeRedundant()) {
                this.setRedundantBlockConfig(this.node.config.isRedundant);
            }
        }

        /**
         * Method to define a block as redundant or not
         *
         * @param isRedundant boolean true if redundancy has been selected, false otherwise
         */
        // TODO: This method may be used in the future for different nodes, currently is only made for the ATEME-DR5000
        // TODO: ATEME-DR5000 only has one block and if it's redundant 2 but in the future it may change
        private setRedundantBlockConfig(isRedundant: boolean): void {
            if (this.node && this.$scope.blocks && this.$scope.blocks.length > 0 && this.$scope.blocks[1].configAsJsonString != undefined) {
                this.$scope.blocks[1].config = Models.BlockConfig.Copy(JSON.parse(this.$scope.blocks[1].configAsJsonString));
                this.$scope.blocks[1].config.isRedundant = isRedundant !== undefined ? isRedundant : false;
                this.$scope.blocks[1].configAsJsonString = JSON.stringify(this.$scope.blocks[1].config);
                if (this.canBeRedundant() && this.node.config && !this.node.config.isRedundant) {
                    this.$scope.blocks[0].configAsJsonString = "{}";
                }
            }
        }

        private loadExistingBlocks(): ng.IPromise<void> {
            this.formValidatorHelper.lastCheckedSerial = this.$scope.node.mftSerialNumber;
            return this.blockService.blocksInNode(Common.Utils.idFromHref(this.$scope.node.href)).then((result: IBlock[]) => {
                this.originalBlocks = result;
                this.$scope.blocks = result.filter((block: IBlock) => {
                    let blockType: Models.BlockTypeNaturalKey = block.blockType.naturalKey;
                    return blockType !== 'MVP_SERVER' && blockType !== 'MVP_SERVER_TS' && blockType !== 'MVP_EXPORT';
                }).sort((b1: IBlock, b2: IBlock) => b1.config.index - b2.config.index)
                .map((block: IBlock, i: number) => {
                    const configCopy: Models.IBlockConfig = Models.BlockConfig.Copy(block.config);
                    const configAsJsonString: string = JSON.stringify(block.config);
                    return {
                        id: block.id,
                        name: block.name,
                        blockTypeId: i,
                        appIndex: i,
                        blockIndex: i,
                        naturalKey: block.blockType.naturalKey,
                        href: block.href,
                        config: configCopy,
                        configAsJsonString: configAsJsonString,
                        lockedName: block.lockedName,
                        blockConnections: block.blockConnections,
                        isConnected: this.checkInUse(block),
                        suffix: block.suffix,
                        hasInputTargetPort: this.hasInputConnections(block.blockConnections),
                        hasOutputTargetPort: this.hasOutputConnections(block.blockConnections)
                    };
                });
                this.setBlocksTypeToShow();
                this.loadPresetPathsInNode();
                if (this.$scope.blocks.length > 0 && this.$scope.blocks[0].config.forwardBlockId) {
                    this.loadvstdNames(this.$scope.blocks[0].config.forwardBlockId.toString());
                }

                this.updateBlockLimit();

                this.getDefaultBlocksNames(this.$scope.blocks.length).then((res: IBlockName[]) => {
                    if (res) {
                        this.autoGeneratedBlockNames = {};
                        this.$scope.presetBlockNames = [];
                        res.forEach( (b: IBlockName, i: number) => {
                            this.autoGeneratedBlockNames[b.name] = b;
                            this.$scope.presetBlockNames[i] = b.name;
                        });
                    }
                });
            });
        }

        private loadPresetPathsInNode(): void {
            this.presetPathService.nodesPresetPath(this.$scope.node.id)
                .then((result: PresetPathsNode) => {
                    this.$scope.blocks.forEach( (block: IBlockName) => {
                        if (result[block.id].length > 0) {
                            block.presetPath = result[block.id];
                        } else {
                            block.presetPath = undefined;
                        }
                    });
                    this.$scope.somePresetPath = this.$scope.blocks.some((blk: IBlockName) => {
                        return blk.presetPath !== undefined;
                    });
                });
        }
        private loadvstdNames(blockId: string): void {
            this.blockService.findById(blockId)
                .then((result: IBlock) => {
                    this.blockService.getNodeFromBlock(result).then( (node: INetworkNode) => {
                        this.blockService.findBlocksByNetworkNodeHrefAndBlockTypeNaturalKey(Common.Utils.strIdFromHref(node.href),
                            "V_TS_DESTINATION").then( (blocks: IBlock[]) => {
                                this.$scope.vtsdForwardBlocks = blocks;
                        });
                    });

                });
        }

        private deleteBlock(block: IBlockName): void {
            let description: string = '';
            let type: string = '';
            if (this.$scope.blocks.length === 1 && this.$scope.blocks[0].href === block.href) {
                // We are trying to delete the last block, in that case we will delete the whole network node
                description = 'Removing all blocks will remove the Network Node. This action cannot be undone.';
                type = 'warning';
            } else {
                description = 'This action cannot be undone.';
                type = 'information';
            }

            this.modalService.showModal({
                templateUrl: ConfirmModalController.templateURL,
                controller: ConfirmModalController.$name,
                inputs: {
                    title: 'Delete block',
                    description,
                    name: block.name,
                    type,
                },
            }).then((modal: ngModal.IModalObject) => {
                let modalElem: UIkit.ModalElement = UIkit.modal(Application.Controllers.ConfirmModalController.ID,
                    { bgclose: false, modal: false, keyboard: false });
                modalElem.show();
                modal.close.then((result: string) => {
                    modalElem.hide();
                    if (result) {
                        if (this.isEditionMode()) {
                            this.$scope.toDeleteBlocks.push(block);
                            this.$scope.blocks = this.$scope.blocks.filter((currentBlock: IBlockName) => {
                                return block.href !== currentBlock.href;
                            });
                        } else {
                            this.$scope.node.config.numberOfBlocks = Number(this.$scope.node.config.numberOfBlocks) || this.$scope.blocks.length;
                            this.$scope.node.config.numberOfBlocks--;
                            this.$scope.changeNumberOfBlocks();
                        }
                        if (this.$scope.blockLimit > this.$scope.blocks.length) {
                            this.$scope.blockLimit=this.$scope.blocks.length;
                        }
                    }
                });
            });
        }

        /**
         * Method to set the Block type displayed in the Blocks tab while creating or editing a node
         */
        private setBlocksTypeToShow(): void {
            if (this.$scope.blocks.length > 0) {
                this.$scope.blocks.forEach((block: IBlockName, blockIndex: number) => {
                    let blockType: Models.BlockTypeNaturalKey = block.naturalKey;
                    let moreOfThisType: boolean = this.$scope.blocks.filter((auxBlock: IBlockName, auxBlockIndex: number) => {
                        return  blockIndex !== auxBlockIndex && auxBlock.naturalKey === blockType;
                    }).length > 0;
                    let humanReadableBlockNaturalKey: string = Models.BlockType.naturalKeyMap[block.naturalKey as string];
                    //TODO: This is a temporary solution for the Ateme DR5000 redundancy. It has to be refactored in the future.
                    if (moreOfThisType && block.appIndex !== undefined && block.naturalKey !== BlockTypeNaturalKey.ATEME_DR5000) {
                        block.typeToShow = humanReadableBlockNaturalKey + ' ' + ((block.config && block.config.index) ? block.config.index : block.appIndex);
                    }  else if ( block.naturalKey === BlockTypeNaturalKey.ATEME_DR5000) {
                        if (block.blockIndex != undefined && block.blockIndex >= 0  && block.blockIndex < 2) {
                            block.typeToShow = humanReadableBlockNaturalKey + ' ' + ((block.blockIndex === 0) ? 'PRIM' : 'SEC');
                        } else {
                            block.typeToShow = humanReadableBlockNaturalKey + ' UNDEFINED';
                        }
                    } else {
                        block.typeToShow = humanReadableBlockNaturalKey;
                    }
                });
            }
        }

        private addParsleyValidateIp(): void {
            window.Parsley
            .addValidator(NetworkNodeModalController.PARSLEY_VALIDATE_IP, {
                validateString: (ip: string): boolean => {
                    return Common.Utils.validateIPAddress(ip);
                },
                messages: {
                    en: 'The ip address is not valid',
                },
            });
        }

        private addParsleyValidateMulticast(): void {
            window.Parsley
              .addValidator(NetworkNodeModalController.PARSLEY_VALIDATE_MULTICAST, {
                  validateString: (ip: string): boolean => {
                      let valid: boolean = true;
                      if(this.$scope.node.config.srtMulticastIterateIp) {
                          valid = this.validateSrtRxMulticast(ip);
                      }
                      return valid;
                  },
                  messages: {
                      en: 'IP address out of range. Please update the multicast IP or change the number of blocks',
                  },
              });
        }


        /**
         * Check if the serial is empty
         */
        private checkIfEmptySerial(): void {
            if (this.$scope.node.type.needsMftSerial() && (
                    this.$scope.node.mftSerialNumber === undefined || this.$scope.node.mftSerialNumber.length === 0)) {
                this.formValidatorHelper.lastCheckedSerialValid = false;
                ValidationUtils.toggleParsleyWarningClasses('node-serial-number', false, "Serial");
            } else {
                if (!this.$scope.node.type.needsMftSerial())
                    this.$scope.node.mftSerialNumber = this.$scope.node.name;
            }
        }

        /**
         * Check if the name is empty
         */
        private checkIfEmptyName(): void {
            if (this.$scope.node.name === undefined || this.$scope.node.name.length === 0) {
                this.formValidatorHelper.lastCheckedNameValid = false;
                ValidationUtils.toggleParsleyWarningClasses('node-name', false, "Name");
            }
        }

        /**
         * Check if the current serial is the same as it was when we started editing
         */
        private checkIfUnchangedSerial(): void {
            if (this.$scope.originalNode.mftSerialNumber &&
                (this.$scope.node.mftSerialNumber === this.$scope.originalNode.mftSerialNumber)) {
                this.formValidatorHelper.lastCheckedSerialValid = true;
                this.formValidatorHelper.lastCheckedSerial = this.$scope.originalNode.mftSerialNumber;
                ValidationUtils.toggleParsleyWarningClasses('node-serial-number', false, "Name");
            }
        }

        /**
         * Check if the current name is the same as it was when we started editing
         */
        private checkIfUnchangedName(): void {
            if (this.$scope.originalNode.name &&
                (this.$scope.node.name === this.$scope.originalNode.name)) {
                this.formValidatorHelper.lastCheckedNameValid = true;
                this.formValidatorHelper.lastCheckedName = this.$scope.originalNode.name;
                ValidationUtils.toggleParsleyWarningClasses('node-name', false, "Name");
            }
        }

        private cleanSelectNodeType(): void {
            this.validateType(true);
        }

        private validateType(clean?: boolean): void {
            let element: JQuery = $("#node-type");
            if (this.$scope.node.type.href !== undefined || clean) {
                if (element.length) {
                    element.parent().removeClass('md-input-wrapper-danger');
                    element.parent().next().remove();
                    element.removeClass('md-input-danger');
                    element.removeAttr('data-parsley-id');
                }
            } else {
                if (element.length) {
                    element.parent().addClass('md-input-wrapper-danger');
                    element.parent().parent().append(
                        `<div class="parsley-errors-list filled custom-type-error" id="parsley-id-1432">
                            <span class="parsley-required">This value is required.</span>
                        </div>`,
                    );
                    element.attr('data-parsley-id', "1432");
                    element.addClass('md-input-danger"');
                }
            }
        }

        // noinspection JSMethodCanBeStatic,JSMethodCanBeStatic
        private isCustomErrorDisplayed(): boolean {
            let element: JQuery = $("#node-type");
            let errorElement: JQuery = element.parent().next();
            return element.length > 0 && errorElement.length > 0 && errorElement.hasClass('custom-type-error');
        }

        private checkInUse(block: IBlock | IBlockName): boolean {
            return (block.config.monitoring != undefined) || (block.blockConnections &&
                block.blockConnections.some((blockConnection: IBlockConnections) => blockConnection.connected));
        }

        private hasInputTargetPort(block: IBlock | IBlockName): boolean {
            return this.hasInputConnections(block.blockConnections);
            }

        private hasInputConnections(blockConnections: IBlockConnections[]): boolean {
            return this.canHaveInput() && blockConnections &&
              blockConnections.some((blockConnection: IBlockConnections) => this.isInput(blockConnection));
        }

        private canHaveInput(): boolean {
            return !(this.nodesWithoutInput.indexOf(this.$scope.node.type.id) > -1);
        }

        private isInput(blockConnection: IBlockConnections): boolean {
            return blockConnection.direction === BlockConnections.DIRECTION_INPUT && blockConnection.push &&
                blockConnection.connectionTypeName !== "SDI" && blockConnection.connectionTypeName !== "TSoIP";
        }

        private hasOutputTargetPort(block: IBlock | IBlockName): boolean {
            return this.hasOutputConnections(block.blockConnections);
            }

        private hasOutputConnections(blockConnections: IBlockConnections[]): boolean {
            return this.canHaveOutput() && blockConnections &&
              blockConnections.some((blockConnection: IBlockConnections) => this.isOutput(blockConnection));
        }

        private canHaveOutput(): boolean {
            return !(this.nodesWithoutOutput.indexOf(this.$scope.node.type.id) > -1);
        }

        private isOutput(blockConnection: IBlockConnections): boolean {
            return blockConnection.direction === BlockConnections.DIRECTION_OUTPUT && blockConnection.push === false && blockConnection.connectionTypeName !== "SDI";
        }

        private openSONHostnameModal(): void {
            const options: ngModal.IShowModalParameters = {
                templateUrl: SONHostnameModalController.templateUrl,
                controller: SONHostnameModalController.$name,
                inputs: {
                    title: `Select ${this.node.name} IP range`,
                    selectType: "node",
                    nodeHostname: this.node.config.sonHostname,
                    networkNodeType: this.node.type,
                },
            };
            this.modalService.showModal(options).then((modal: ngModal.IModalObject) => {
                let modalElem: UIkit.ModalElement = UIkit.modal(Controllers.SONHostnameModalController.ID,
                    {bgclose: false, modal: false, keyboard: false});
                modalElem.show();
                modal.close.then((element: ISONDNSEntry) => {
                    if (element) {
                        if (element.isIpRange) {
                            this.node.config.sonHostname = element.hostname;
                            modalElem.hide();
                            this.sonAdapterService.getSONDnsMap(element.hostname).then((dnsMap: ISONDnsMap) => {
                                this.selectBlocksFromDnsEntries(dnsMap.children);
                            });
                        } else {
                            this.$scope.node.config.numberOfBlocks = 1;
                            if (!this.isEditionMode()) this.$scope.blocks = undefined;
                            this.sonAdapterService.getSONDnsMap(element.hostname).then( (dnsMap: ISONDnsMap) => {
                                if (dnsMap.children.length > 0) {
                                    this.updateNetworkInterfaceInfo(dnsMap);
                                    const firstSignal: ISONDNSEntry = dnsMap.getFirstSignal();
                                    this.node.config.sonHostname = dnsMap.entry.hostname;
                                    this.sonDnsEntry = firstSignal;
                                    this.updateBlocksDnsConfig(firstSignal).then();
                                } else {
                                    this.node.config.sonHostname = element.hostname;
                                    this.sonDnsEntry = element;
                                    this.updateBlocksDnsConfig(element).then();
                                }
                            });
                        }
                    } else {
                        this.node.config.useSon = false;
                    }
                });
            });
        }

        private async updateBlocksDnsConfig(sonDnsEntry: ISONDNSEntry): Promise<void> {
            const blocksLoaded: boolean = await this.loadBlocksIfNeeded();
            if (!blocksLoaded && this.$scope.blocks && this.$scope.blocks.length > 0) {
                const theBlock: IBlockName = this.$scope.blocks[0];
                theBlock.config = new BlockConfig();
                this.setConfigFromDnsEntry(theBlock, sonDnsEntry);
                theBlock.configAsJsonString = JSON.stringify(theBlock.config);
            }
        }

        private async loadBlocksIfNeeded(): Promise<boolean> {
            if (!this.$scope.blocks || this.$scope.blocks.length === 0) {
                await this.loadBlocks();
                return true;
            } else {
                return false;
            }
        }

        private openBlockSONHostnameModal(block: IBlockName): void {
            const sonHostName: string = this.node.config.sonHostname;
            const options: ngModal.IShowModalParameters = {
                templateUrl: SONHostnameModalController.templateUrl,
                controller: SONHostnameModalController.$name,
                inputs: {
                    title: `Select ${block.name} IP range`,
                    selectType: "block",
                    nodeHostname: sonHostName,
                    networkNodeType: this.node.type,
                },
            };
            this.modalService.showModal(options).then((modal: ngModal.IModalObject) => {
                let modalElem: UIkit.ModalElement = UIkit.modal(Controllers.SONHostnameModalController.ID,
                    {bgclose: false, modal: false, keyboard: false});
                modalElem.show();
                modal.close.then((element: ISONDNSEntry) => {
                    if (element) {
                        block.config.sonHostname = element.hostname;
                        if (block.config.ts) {
                            let newIp: string = element.ip;
                            if (newIp.indexOf("/") > 0) {
                                newIp = newIp.substring(0, newIp.indexOf("/"));
                            }
                            block.config.ts.ip = newIp;
                        }
                        this.$timeout(() => {
                            block.configAsJsonString = JSON.stringify(block.config);
                        }, 0);

                        modalElem.hide();
                    }
                });
            });
        }

        private selectBlocksFromDnsEntries(entries: ISONDnsMap[]): void {
            this.modalService.showModal({
                templateUrl: Controllers.DualListModalController.templateUrl,
                controller: Controllers.DualListModalController.$name,
                inputs: {
                    title: `Select Blocks to create in ${this.$scope.node.name}`,
                    titleElements: `DNS entries`,
                    titleSelectedElements: `Blocks to be created`,
                    firstColumn: "Name",
                    secondColumn: "IP",
                    elements: entries,
                    selectedElements: [],
                    idProperty: 'fullName',
                    nameProperty: 'nodeName',
                    secondColumnProperty: "entry.ip",
                    noMoreToAddText: 'No blocks to add',
                    noneSelectedText: 'No blocks selected',
                    secondaryInfoCompare: undefined,
                    highlightedId: undefined,
                    type: Controllers.DualListModalController.blockType,
                },
            }).then((modal: ngModal.IModalObject) => {
                let modalElem: UIkit.ModalElement = UIkit.modal(Controllers.DualListModalController.ID,
                    {bgclose: false, modal: false, keyboard: false});
                modalElem.show();
                modal.close.then((result: {selected: ISONDnsMap[], unselected: ISONDnsMap[]}) => {
                    this.createTSBlocksWithAddresses(result.selected);
                });
            });

        }

        private createTSBlocksWithAddresses(addresses: ISONDnsMap[]): void {
            this.$scope.node.config.numberOfBlocks = addresses.length;
            this.getDefaultBlocksNames(addresses.length).then((result: IBlockName[]) => {
                if (result && result.length > 0) {
                    this.$scope.blocks = result.map((block: IBlockName, i: number) => {
                        const sonDnsMap: ISONDnsMap = addresses[i];
                        const sonDnsEntry: ISONDNSEntry = sonDnsMap.entry;
                        let jsonConfig: string = block.configAsJsonString ? block.configAsJsonString : JSON.stringify(block.config);
                        block.config = jsonConfig ? JSON.parse(jsonConfig) : block.config;
                        this.setConfigFromDnsEntry(block, sonDnsEntry);
                        jsonConfig = JSON.stringify(block.config);
                        return {
                            name: this.$scope.node.name + "_" + sonDnsMap.nodeName,
                            blockTypeId: block.blockTypeId,
                            appIndex: block.appIndex,
                            blockIndex: i,
                            naturalKey: block.naturalKey,
                            href: block.href,
                            config: block.config,
                            configAsJsonString: jsonConfig,
                            lockedName: block.lockedName,
                        };
                    });
                    this.autoGeneratedBlockNames = {};
                    this.$scope.presetBlockNames = [];
                    this.$scope.blocks.forEach((block: IBlockName, i: number) => {
                        this.autoGeneratedBlockNames[block.name] = block;
                        this.$scope.presetBlockNames[i] = block.name;
                    });
                }
                this.setBlocksTypeToShow();

            });
        }

        private shouldShowSpecifics(): boolean {
            return this.$scope.isSrt || (!this.isEditionMode() && this.$scope.isNumberOfBlocksEditable && !this.$scope.isIntinor) || this.$scope.node.type.name === "MEDIAKIND RX8200";
        }

        private isEditionMode(): boolean {
            return this.$scope.editionMode;
        }

        private setSpecificsVisibility(): void {
            this.shouldShowSpecifics()
                ? this.enableStep(this.getSpecificsStepTitle())
                : this.disableStep(this.getSpecificsStepTitle());
            this.setSpecificsTitle();
        }

        private setSpecificsTitle(): void {
            this.$scope.steps.SPECIFICS_STEP = this.$scope.node.type.getTextForSpecificsTab()
                || NetworkNodeModalController.STEPS.SPECIFICS_STEP;
        }

        private setConfigFromDnsEntry(block: Application.Models.IBlockName, sonDnsEntry: Application.Models.ISONDNSEntry): void {
            block.config.sonHostname = sonDnsEntry.hostname;
            if (!block.config.ts) {
                block.config.ts = {} as IBlockConfigTS;
            }
            block.config.ts.ip = sonDnsEntry.ip.split("/")[0];
            block.config.ts.port = 6501;
        }

        private getDetailsStepTitle(): string {
            return this.$scope.steps.DETAILS_STEP;
        }

        private getSpecificsStepTitle(): string {
            return this.$scope.steps.SPECIFICS_STEP;
        }

        private async enableAndGoToSpecifics(): Promise<void> {
            await this.enableAndGoToStep(this.getSpecificsStepTitle());
        }

        private getLocationStepTitle(): string {
            return this.$scope.steps.LOCATION_STEP;
        }

        private async enableAndGoToLocation(): Promise<void> {
            await this.enableAndGoToStep(this.getLocationStepTitle());
        }

        private getNetworkStepTitle(): string {
            return this.$scope.steps.NETWORK_STEP;
        }

        private async enableAndGoToNetwork(): Promise<void> {
            await this.enableAndGoToStep(this.getNetworkStepTitle());
        }

        private getBlocksStepTitle(): string {
            return this.$scope.steps.BLOCKS_STEP;
        }

        private async enableAndGoToBlocks(): Promise<void> {
            await this.enableAndGoToStep(this.getBlocksStepTitle());
        }

        private disableStep(stepTitle: string): void {
            this.$scope.isDisabledMap[stepTitle] = true;
        }

        private enableStep(stepTitle: string): void {
            this.$scope.isDisabledMap[stepTitle] = false;
        }

        private updateCpusToUse(): void {
            const cpus: number = this.$scope.node.config.cpus;
            const offset: number = this.$scope.node.config.cpusOffset;
            if (cpus > 100) return; // in case someone feels playful
            this.$scope.cpusToUseText = isNaN(offset)
                ? ''
                : Common.Utils.rangeForNgRepeat(cpus)
                    .map((cpu: number) => cpu + offset)
                    .join(', ');
        }

        private updateNumberOfBlocks(): void {
            if (!this.isEditionMode()) {
                if (this.$scope.isSrt) {
                    this.$scope.node.config.numberOfBlocks = this.$scope.node.config.cpus > 0
                        ? this.$scope.node.config.cpus * this.$scope.connectionsPerCpu
                        : 0;
                    this.$scope.changeNumberOfBlocks();
                }
            }
        }

        private setPristine(): void {
            (this.$scope as any).wizardModalForm.$setPristine(); // tslint:disable-line
        }

        private async renameBlocks(): Promise<void> {
            this.getDefaultBlocksNames(this.$scope.blocks.length).then((res: IBlockName[]) => {
                if (res) {
                    this.autoGeneratedBlockNames = {};
                    this.$scope.presetBlockNames = [];
                    res.forEach( (b: IBlockName, i: number) => {
                        this.autoGeneratedBlockNames[b.name] = b;
                        this.$scope.presetBlockNames[i] = b.name;
                        if (this.$scope.blocks[i] && this.$scope.blocks[i].suffix && !this.$scope.blocks[i].lockedName) {
                            this.$scope.blocks[i].name = this.$scope.node.alias ?
                                this.$scope.node.alias + "_" + this.$scope.blocks[i].suffix
                                : this.$scope.node.name + "_" + this.$scope.blocks[i].suffix;
                        } else if (this.$scope.blocks[i] && !this.$scope.blocks[i].lockedName) {
                            this.$scope.blocks[i].name = b.name;
                        }
                    });
                }
            });
        }

        private async blockRenamed(block: IBlockName): Promise<void> {
            let autoGeneratedBlockName: string = Object.keys(this.autoGeneratedBlockNames)[block.blockIndex];
            const prefix: string = this.$scope.node.alias ? this.$scope.node.alias : this.$scope.node.name;
            const logicalName: string = block.suffix ? prefix + "_" + block.suffix : autoGeneratedBlockName;
            block.lockedName = logicalName !== block.name;
        }

        private suffixChanged(block: IBlockName): void {
            if (!block.lockedName) {
                if (block.suffix !== "") {
                    const prefix: string = this.$scope.node.alias ? this.$scope.node.alias : this.$scope.node.name;
                    block.name = prefix + "_" + block.suffix;
                } else {
                    block.name = Object.keys(this.autoGeneratedBlockNames)[block.blockIndex];
                }
            }
        }

        private updateBlockLimit() {
            this.$scope.blockLimit = this.$scope.blocks.length > 20 ? 20 : this.$scope.blocks.length;
        }

        private getDefaultBlocksNames(numberOfBlocks: number): ng.IPromise<IBlockName[]> {
            const typeId: string = '' + this.$scope.node.type.id;
            const name: string = this.$scope.node.alias ? this.$scope.node.alias : this.$scope.node.name;
            numberOfBlocks = this.$scope.node.type.isNumberOfBlocksEditable() ? numberOfBlocks : undefined;

            let blockNameParameters: IBlockNameParameters = {
                nodeName: name,
                numberOfBlocks: numberOfBlocks
            }

            if (this.$scope.node.type.isSrt) {
                blockNameParameters.cpus = this.$scope.node.config.cpus;
                blockNameParameters.cpusOffset = this.$scope.node.config.cpusOffset;
            }

            return this.blockService.getDefaultBlocksNamesWithParameters(typeId, blockNameParameters);
        }

        private validateSrtRxMulticast(ip: string) {
            let nAddress = this.ipService.getNumberOfAddresses(ip, this.MULTICAST_MAX_IP);
            return nAddress >= this.$scope.node.config.numberOfBlocks;
        }

        /**
         * Method invoked to update the ip and port of a multicast connection
         */
        private updateIpsAndPorts(): void {
            if (this.$scope.blocks) {
                const ip: string = this.$scope.node.config.srtMulticastIpAndPort ? this.$scope.node.config.srtMulticastIpAndPort.ip : undefined;
                let ipValues: number[] = ip && ip !== "" ? ip.split('.').map((value) => {return +value;}) : undefined;
                this.$scope.blocks.forEach((block: IBlockName, i: number) => {
                    block.config = block.config ? block.config : new BlockConfig();
                    let blockIp:string = undefined;
                    // Needed to refresh the pattern error, empty string pass the validation
                    this.existMulticastPatternError('');

                    // If there is a multicast ip we fill the port, otherwise it will be undefined
                    let port: number = undefined;

                    if (ip && ip !== "") {
                        if (this.$scope.node.config.srtMulticastIterateIp ) {
                            blockIp = this.ipService.incrementIp(ip, i);
                            port = this.$scope.node.config.srtMulticastIpAndPort.port;
                        } else {
                            blockIp = ip;
                        }

                        if (!this.$scope.node.config.srtMulticastIpAndPort.port) {
                            port = Models.DEFAULT_PORT;
                        } else if (!port) {
                            port = this.$scope.node.config.srtMulticastIpAndPort.port + i;
                        }
                    } else if (this.$scope.node.config.srtMulticastIpAndPort) {
                        this.$scope.node.config.srtMulticastIpAndPort.port = undefined;
                    }
                    if (blockIp) {
                        block.config.ts = new BlockConfigTS(blockIp, port);
                        this.$scope.jsonConfigChanged(block);
                    }
                });
            }
        }

        private async updateNetworkProbes(probedBlocks: Models.IAllProbedBlocks, blocksBeforeUpdate: Models.IBlock[]): Promise<void> {
            // check if vts the multicast of any vts block has changed
            for (const block of this.$scope.blocks) {
                if (block.config.ts) {
                    let blockBeforeUpdate = blocksBeforeUpdate.filter((bl: IBlock) => bl.id === block.id)[0];
                    if(blockBeforeUpdate.config.ts.ip !== block.config.ts.ip || blockBeforeUpdate.config.ts.port !== block.config.ts.port) {
                        // if multicast has changed, find the connected blocks related to this one
                        let connectedBlocks: Block[] = await this.blockService.getConnectedBlocks(block.id);
                        for (const connectedBlock of connectedBlocks) {
                            // if it has a multicast ip in the config, check if it is probed and do the reprobe.
                            if (block.config.ts) {
                                let res: Models.IFindByTsResults = await this.tsprobeService.getConnectedProbeByBlockId(connectedBlock.id, probedBlocks);
                                if (res && res.selectedStream.ip !== connectedBlock.config.ts.ip || res.selectedStream.port !== connectedBlock.config.ts.port) {
                                    let stopped: Models.ProbeOperationResult = await this.tsprobeService.disconnectProbeByBlockId(connectedBlock.id);
                                    if (stopped) {
                                        await this.tsprobeService.connectProbeByBlockId(connectedBlock.id, res.defaultTsProbe.tsProbe.networkNodeId);
                                    }
                                }
                            }
                        }
                        // if the block itself is probed, do the reprobe
                        let res: Models.IFindByTsResults = await this.tsprobeService.getConnectedProbeByBlockId(block.id, probedBlocks);
                        if (res && res.selectedStream.ip !== block.config.ts.ip || res.selectedStream.port !== block.config.ts.port) {
                            let stopped: Models.ProbeOperationResult = await this.tsprobeService.disconnectProbeByBlockId(block.id);
                            if (stopped) {
                                await this.tsprobeService.connectProbeByBlockId(block.id, res.defaultTsProbe.tsProbe.networkNodeId);
                            }
                        }
                    }
                }
            }
        }

        /**
         * Performs the form validation
         * @private
         */
        private validateForm() {
            $("[name=\"wizardModalForm\"]").parsley().validate();
        }


        private addSRTParameters(jsonConfig: string, params: {}) {
            let json = JSON.parse(jsonConfig);
            json["srtConfig"] = params;
            return JSON.stringify(json);
        }

        private createSrtParamsConfig() {
            let params = {};
            //add params to change
            params["SRT_PROCESS_RTP2UDP"] = this.$scope.node.config.processRtp2Udp ? this.$scope.node.config.processRtp2Udp : false;
            return params;
        }
    }
}
